var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.84,78.47l-23.28,82.12a4.46,4.46,0,0,1-5.78,3l-60.66-20.48,24.21-83.33,61.76,12.57A4.9,4.9,0,0,1,426.84,78.47Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,163.81l-.29-.09-60.8-20.53,0-.14,24.26-83.46,61.89,12.59A5,5,0,0,1,427,78.51l-23.27,82.12a4.61,4.61,0,0,1-5.69,3.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.06 71.49 426.16 75.09 402.28 159.36 401.79 161.1 395.67 159.35 421.06 71.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,59.52s24.3-2.24,60,11.63l-25.51,88.31L337.2,141.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,59.52s0,.13-.11.39-.19.64-.33,1.15c-.3,1-.73,2.51-1.29,4.45-1.14,3.9-2.79,9.6-4.89,16.82-4.2,14.43-10.17,34.93-17.25,59.23l0-.09,58.4,17.92-.1.05c.3-1,.63-2.17,1-3.31,9.23-31.91,17.75-61.4,24.57-85l0,.07a188.13,188.13,0,0,0-24.19-7.62,155.48,155.48,0,0,0-19.07-3.41,115.21,115.21,0,0,0-12.34-.78l-1.88,0-1.36,0-1.1.06.27,0,.83-.05,1.36,0,1.88,0a111.21,111.21,0,0,1,12.35.75,155.2,155.2,0,0,1,19.08,3.38,189.11,189.11,0,0,1,24.21,7.6l.06,0,0,0c-6.81,23.6-15.32,53.09-24.54,85-.32,1.13-.65,2.26-.95,3.3l0,.08-.08,0L337.18,141.6l-.07,0,0-.06c7.11-24.31,13.11-44.81,17.33-59.25l4.92-16.79c.57-1.94,1-3.43,1.3-4.44L361,59.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,60c-1.58,6.36-7.94,29.25-7.94,29.25l4.65-3.92,2.18,5,8.4-32h-5.22A2.14,2.14,0,0,0,363.78,60Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.46,159.87l.06-.22c0-.16.1-.38.18-.67.16-.59.4-1.44.71-2.55l2.66-9.36c2.26-7.9,5.45-18.79,9-30.81s6.73-22.92,9-30.81c1.14-3.94,2.07-7.13,2.71-9.35l.74-2.54c.08-.28.15-.5.2-.66s.07-.22.07-.22l-.06.23-.18.66c-.16.59-.4,1.45-.71,2.55l-2.66,9.36c-2.27,7.9-5.45,18.79-9,30.82l-9,30.8c-1.15,4-2.07,7.14-2.71,9.35l-.74,2.54c-.09.29-.15.51-.2.66A1.8,1.8,0,0,1,397.46,159.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,160.33s5.5-19.44,12.37-43.4S423.92,73.56,424,73.57,418.47,93,411.59,117,399.11,160.34,399.07,160.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.36,38.48l-24.1,85a2.93,2.93,0,0,0,2.3,3.55l64.56,16.06c1.55.36,1.37-2.73,1.77-4.15L344.11,55a2.9,2.9,0,0,0-2-3.46l-44-14.87A2.91,2.91,0,0,0,294.36,38.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.69 38.45 280.1 127.9 337.49 141.81 361.33 59.76 304.69 38.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,38.45S346.35,41.83,361,60.33l-23.84,82-52.54-13.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.57,37.89c-.18.65-10.6,37.53-25.55,90.43l0-.09L334.47,141l3,.78-.1.05,23.86-82,0,0c-.71-.81-1.36-1.66-2.12-2.39l-.54-.57a7.27,7.27,0,0,0-.56-.55l-1.14-1a44.53,44.53,0,0,0-4.77-3.66,55.77,55.77,0,0,0-4.87-2.94c-.81-.43-1.62-.85-2.42-1.24l-1.2-.57c-.4-.19-.79-.38-1.19-.55a90.85,90.85,0,0,0-9-3.42c-2.83-.92-5.46-1.64-7.84-2.23-4.76-1.17-8.54-1.82-11.11-2.21-1.28-.2-2.27-.33-2.93-.41l-1-.12s.35,0,1,.1,1.65.2,2.94.39c2.57.38,6.35,1,11.12,2.18,2.38.59,5,1.3,7.84,2.21a93.68,93.68,0,0,1,9,3.42c.4.17.8.35,1.19.55l1.21.56c.8.39,1.6.82,2.42,1.24,1.62.9,3.27,1.84,4.89,2.94A47.18,47.18,0,0,1,357,55.15l1.14,1.05a7.27,7.27,0,0,1,.56.55l.55.57c.76.74,1.42,1.59,2.12,2.41l0,0v0c-6.53,22.49-14.81,51-23.82,82.05l0,.07-.07,0-3-.78-49.5-12.73-.08,0,0-.07C299.91,75.4,310.39,38.54,310.57,37.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.77 39.07 304.69 38.45 280.1 127.9 272.73 123.89 296.77 39.07",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.22,122.7S280.45,104,287,80.88s11.88-41.79,11.93-41.78-5.23,18.73-11.78,41.82S275.26,122.71,275.22,122.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.25 52.4 286.88 64.85 290.38 76.61 297.25 52.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,122.76s5-17.86,11.22-39.87,11.33-39.84,11.37-39.83-5,17.86-11.22,39.87S277.35,122.77,277.3,122.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.3,126.42s5.27-18.87,11.85-42.11,12-42.07,12-42.06-5.26,18.86-11.85,42.11S278.34,126.43,278.3,126.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,65.84a7.82,7.82,0,0,1-1.22-.75c-.76-.52-1.88-1.24-3.29-2.09a72.49,72.49,0,0,0-23.8-9.21c-1.61-.32-2.92-.54-3.83-.67a7.3,7.3,0,0,1-1.41-.27,9,9,0,0,1,1.43.08c.92.07,2.25.24,3.88.52a64.64,64.64,0,0,1,23.92,9.26c1.39.89,2.48,1.65,3.21,2.22A8.09,8.09,0,0,1,350.19,65.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.09,72.89a7.09,7.09,0,0,1-1.23-.75c-.76-.52-1.88-1.23-3.28-2.08a72.81,72.81,0,0,0-23.8-9.22c-1.61-.31-2.93-.54-3.84-.67a8.63,8.63,0,0,1-1.4-.26A7,7,0,0,1,316,60c.92.07,2.24.25,3.87.52a64.46,64.46,0,0,1,23.92,9.26c1.39.89,2.49,1.66,3.22,2.22A8.09,8.09,0,0,1,348.09,72.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,80a10,10,0,0,1-1.22-.76c-.76-.51-1.88-1.23-3.29-2.08a72.49,72.49,0,0,0-23.8-9.21c-1.61-.32-2.92-.54-3.83-.67a8.42,8.42,0,0,1-1.41-.27,7.67,7.67,0,0,1,1.43.08c.92.07,2.25.24,3.88.51a65.1,65.1,0,0,1,23.92,9.26c1.39.9,2.48,1.66,3.21,2.23A8.09,8.09,0,0,1,346,80Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,87a7.57,7.57,0,0,1-1.23-.75c-.76-.52-1.88-1.24-3.28-2.09A72.49,72.49,0,0,0,315.57,75c-1.61-.32-2.93-.54-3.84-.67a7.06,7.06,0,0,1-1.4-.27,9,9,0,0,1,1.43.08c.92.07,2.24.24,3.87.52a64.46,64.46,0,0,1,23.92,9.26c1.39.89,2.49,1.65,3.22,2.22A8.09,8.09,0,0,1,343.88,87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,94.44a7.3,7.3,0,0,1-1.22-.75c-.76-.52-1.88-1.24-3.29-2.09A72.49,72.49,0,0,0,314,82.39c-1.61-.32-2.92-.54-3.83-.67a7.3,7.3,0,0,1-1.41-.27,9,9,0,0,1,1.43.08c.92.07,2.25.24,3.87.52A64.59,64.59,0,0,1,338,91.31c1.38.89,2.48,1.66,3.21,2.22A8.09,8.09,0,0,1,342.29,94.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,104.18a8.25,8.25,0,0,1-1.28-.79c-.4-.27-.89-.59-1.48-1s-1.23-.79-2-1.22c-1.48-.89-3.29-1.86-5.33-2.89s-4.33-2-6.78-3-4.84-1.72-7-2.36-4.19-1.12-5.88-1.45c-.85-.19-1.62-.32-2.29-.44s-1.26-.22-1.74-.29a8,8,0,0,1-1.47-.28,9.33,9.33,0,0,1,1.5.09c.48,0,1.07.1,1.75.21s1.46.2,2.31.37c1.71.28,3.72.76,5.94,1.35s4.61,1.39,7.08,2.34,4.77,2,6.82,3,3.84,2.06,5.3,3c.74.44,1.39.89,1.95,1.28s1.06.73,1.44,1A8.35,8.35,0,0,1,341.05,104.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.73,112.8a8.78,8.78,0,0,1-1.33-.72c-.84-.5-2.07-1.17-3.6-2a89.46,89.46,0,0,0-12.49-5.25c-5-1.7-9.68-2.9-13-3.77l-4-1a9,9,0,0,1-1.45-.44,9.57,9.57,0,0,1,1.49.25c1,.19,2.34.49,4,.88,3.39.79,8.07,1.94,13.12,3.64A77,77,0,0,1,334,109.79c1.52.85,2.73,1.58,3.54,2.13A8.61,8.61,0,0,1,338.73,112.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,121.42a9.07,9.07,0,0,1-1.36-.61c-.87-.42-2.12-1-3.69-1.69a108.66,108.66,0,0,0-12.58-4.57c-5-1.5-9.64-2.53-13-3.19-1.68-.33-3.05-.58-4-.74a9.26,9.26,0,0,1-1.47-.3,8.2,8.2,0,0,1,1.49.11c1,.11,2.34.3,4,.59a111.35,111.35,0,0,1,13.09,3,93,93,0,0,1,12.58,4.73c1.56.72,2.8,1.37,3.64,1.84A9.27,9.27,0,0,1,335,121.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.92,79a10,10,0,0,1-1.63-.48c-1-.35-2.55-.83-4.42-1.41-3.74-1.15-9-2.58-14.81-3.76s-11.22-1.86-15.12-2.24c-1.94-.19-3.52-.32-4.61-.4a11.33,11.33,0,0,1-1.7-.18,1.25,1.25,0,0,1,.44,0l1.27,0c1.09,0,2.68.1,4.63.25a126.34,126.34,0,0,1,15.19,2.09A129.5,129.5,0,0,1,401,76.76c1.87.62,3.36,1.15,4.38,1.56l1.17.47A1.65,1.65,0,0,1,406.92,79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.14,95.1a2.48,2.48,0,0,1-.45-.09l-1.28-.34-4.68-1.28c-4-1.06-9.44-2.45-15.56-3.73s-11.69-2.23-15.74-2.85l-4.8-.72-1.3-.2a1.44,1.44,0,0,1-.46-.11,2.43,2.43,0,0,1,.47,0l1.31.11c1.15.11,2.79.3,4.83.56,4.07.53,9.67,1.43,15.8,2.71s11.61,2.73,15.54,3.89c2,.57,3.56,1.06,4.65,1.43l1.25.42C405,95,405.15,95.08,405.14,95.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,103.12a1.48,1.48,0,0,1-.47-.08l-1.3-.33-4.77-1.28c-4-1.08-9.6-2.53-15.78-4s-11.82-2.68-15.9-3.53l-4.84-1-1.31-.29a1.39,1.39,0,0,1-.45-.14,2.38,2.38,0,0,1,.47,0l1.33.2c1.15.18,2.81.47,4.87.85,4.1.76,9.75,1.92,15.94,3.39s11.76,3,15.77,4.15c2,.58,3.62,1.07,4.73,1.43l1.27.42A3.35,3.35,0,0,1,402.27,103.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,112.5c0,.13-10.05-2.4-22.36-5.65s-22.27-6-22.24-6.13,10.05,2.4,22.36,5.65S400,112.37,400,112.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.56,122.11c0,.13-10-2.47-22.25-5.82s-22.16-6.17-22.12-6.3,10,2.48,22.25,5.82S398.6,122,398.56,122.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.83,132c0,.13-9.91-2.8-22-6.53s-21.94-6.88-21.9-7,9.91,2.8,22,6.53S395.87,131.86,395.83,132Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.89,140.62c0,.14-8.78-2.37-19.53-5.6s-19.42-6-19.38-6.08,8.78,2.38,19.53,5.61S390.93,140.49,390.89,140.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,87.67a1.64,1.64,0,0,1-.45-.09l-1.23-.36-4.53-1.33c-3.82-1.1-9.15-2.49-15.1-3.7s-11.4-2-15.36-2.48l-4.68-.53L364.46,79a2.28,2.28,0,0,1-.44-.08,1.59,1.59,0,0,1,.45,0l1.28.06c1.12.06,2.73.19,4.71.39,4,.39,9.44,1.13,15.42,2.34s11.29,2.66,15.1,3.85c1.91.59,3.44,1.1,4.49,1.48l1.21.44A1.67,1.67,0,0,1,407.09,87.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,154.21s8.31,3.63,9.38,3.22a11.82,11.82,0,0,1,2.27-.56l-9.1-4.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.72,140.3l-68.53,17.1a1.65,1.65,0,0,1-2-1.19c-9.89-37.61-21.15-82.38-24-95.77a1.65,1.65,0,0,1,1.2-1.94L155,41.38a1.65,1.65,0,0,1,2,1.22l23.88,95.69A1.66,1.66,0,0,1,179.72,140.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.4 139.07 110.09 156.65 103.56 154.15 78.09 56.4 149.51 40.44 154.12 43.29 178.4 139.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.4 139.07 170.44 135.3 148.08 39.78 154.12 43.29 178.4 139.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.92,137.08l-69.46,17.34a1.65,1.65,0,0,1-2-1.19c-9.91-37.6-21.16-82.38-24-95.77a1.65,1.65,0,0,1,1.22-1.94l69.52-17.35a1.67,1.67,0,0,1,2,1.2l23.88,95.7A1.66,1.66,0,0,1,171.92,137.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,153.32s-5.58-21.92-12.33-49-12.18-49-12.12-49,5.57,21.9,12.33,49S106.94,153.3,106.88,153.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,133.07l-55.94,14L87.84,58l55.94-14Zm-54.75,12L164,131.89,142.59,46,89.82,59.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.79,
    y: 132.13,
    width: 12.04,
    height: 3.38,
    transform: "translate(-28.36 36.87) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.45,
    y: 55.87,
    width: 5.61,
    height: 3.38,
    transform: "translate(-10.42 30.35) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.63,
    y: 70.72,
    width: 42.27,
    height: 15.07,
    transform: "translate(-15.3 32.06) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.02,
    y: 89.67,
    width: 31.13,
    height: 6.35,
    transform: "translate(-18.74 33.17) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.48,
    y: 69.27,
    width: 4.33,
    height: 2.73,
    transform: "translate(-14.67 21.87) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 73.35,
    width: 4.33,
    height: 2.73,
    transform: "translate(-15.63 22.24) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.47,
    y: 144.04,
    width: 4.01,
    height: 2.73,
    transform: "translate(-32.22 28.66) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.33,
    y: 82.65,
    width: 4.33,
    height: 46.9,
    transform: "translate(-23 25.07) rotate(-14.01)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,42.16l.12.43.32,1.25,1.22,4.8L158,66.33c3.74,14.94,8.9,35.58,14.6,58.37,1.17,4.69,2.31,9.28,3.41,13.67l0,.1-.1,0-49.14,12.23-14.52,3.59-3.91,1-1,.24-.34.07.34-.09,1-.26,3.9-1,14.51-3.65L175.9,138.3l-.07.12-3.42-13.66c-5.67-22.8-10.81-43.45-14.54-58.39-1.85-7.48-3.34-13.52-4.38-17.71-.51-2.09-.91-3.71-1.18-4.81-.13-.55-.24-1-.3-1.26S151.91,42.16,151.91,42.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.11,376.56a30,30,0,0,1,11.77-14.22c1.1,5.83,1,14-1.38,19.44a28.69,28.69,0,0,1-11.22,13.05A29.49,29.49,0,0,1,77.11,376.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.12,370.81a4.5,4.5,0,0,0-.55.86c-.33.55-.79,1.38-1.33,2.41a73,73,0,0,0-3.67,8.33,74.9,74.9,0,0,0-2.6,8.72c-.26,1.13-.44,2.06-.55,2.7a6.52,6.52,0,0,0-.14,1,5.58,5.58,0,0,0,.27-1c.14-.64.37-1.55.65-2.68.58-2.25,1.47-5.33,2.69-8.66a89.3,89.3,0,0,1,3.56-8.33c.51-1,.94-1.88,1.24-2.46A6.73,6.73,0,0,0,85.12,370.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,355.6a30,30,0,0,1,11.77-14.22c1.09,5.83,1,14-1.38,19.45A29.79,29.79,0,0,1,58.54,374,30,30,0,0,1,59.68,355.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.68,349.85a6.55,6.55,0,0,0-.54.86c-.34.56-.79,1.38-1.33,2.41a73,73,0,0,0-3.67,8.33,71.16,71.16,0,0,0-2.6,8.72c-.26,1.14-.45,2.06-.55,2.7a5.17,5.17,0,0,0-.14,1,7.4,7.4,0,0,0,.26-1c.15-.63.37-1.55.66-2.67a88.71,88.71,0,0,1,6.25-17c.51-1,.93-1.88,1.23-2.46A5.06,5.06,0,0,0,67.68,349.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.16,359.77a30.05,30.05,0,0,0-17.53,5.79c5,3.14,12.69,6.06,18.61,5.79a29.78,29.78,0,0,0,16.5-5.92A30.05,30.05,0,0,0,36.16,359.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.89,365.14a4.56,4.56,0,0,1,1-.2c.64-.11,1.57-.23,2.73-.36a73.67,73.67,0,0,1,9.09-.38,71.44,71.44,0,0,1,9.07.75c1.15.17,2.08.33,2.72.47a4.52,4.52,0,0,1,1,.24,6.58,6.58,0,0,1-1-.11c-.65-.1-1.58-.22-2.73-.36-2.31-.29-5.5-.58-9-.66s-6.75.1-9.07.29c-1.15.09-2.09.18-2.74.25A7.36,7.36,0,0,1,27.89,365.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.72,381.55a30,30,0,0,0-17.53,5.78c5,3.14,12.69,6.06,18.61,5.8a29.79,29.79,0,0,0,16.5-5.93A30,30,0,0,0,51.72,381.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.45,386.91a7.22,7.22,0,0,1,1-.2c.64-.11,1.57-.23,2.73-.36a73.26,73.26,0,0,1,18.16.37c1.15.17,2.08.34,2.72.47a5.42,5.42,0,0,1,1,.24,6.58,6.58,0,0,1-1-.11c-.65-.09-1.58-.22-2.73-.36-2.31-.28-5.5-.58-9-.65s-6.75.09-9.07.28l-2.74.25A5.77,5.77,0,0,1,43.45,386.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,405.76a4.47,4.47,0,0,1-.67-.37l-1.87-1.14-1.35-.84c-.49-.32-1-.69-1.56-1.07-1.11-.78-2.4-1.62-3.74-2.69L80.12,398c-.74-.57-1.46-1.22-2.23-1.86-1.56-1.26-3.11-2.75-4.76-4.28A112.72,112.72,0,0,1,63.3,381a111.35,111.35,0,0,1-8.17-12.19c-1.09-2-2.15-3.85-3-5.67-.43-.9-.88-1.76-1.26-2.62l-1.06-2.45c-.71-1.56-1.21-3-1.7-4.28-.23-.64-.46-1.23-.65-1.78s-.34-1.05-.48-1.51c-.28-.88-.49-1.58-.66-2.09a4.39,4.39,0,0,1-.19-.74,5.38,5.38,0,0,1,.28.71c.18.51.43,1.2.73,2.07l.52,1.49c.2.55.44,1.13.69,1.76.51,1.25,1,2.7,1.75,4.24l1.09,2.44c.38.84.84,1.7,1.28,2.59.86,1.81,1.93,3.66,3,5.63a106,106,0,0,0,17.93,23c1.64,1.53,3.17,3,4.71,4.3.77.64,1.48,1.29,2.21,1.87l2.1,1.65c1.32,1.08,2.59,1.94,3.69,2.73.55.4,1.05.77,1.53,1.1l1.32.87,1.83,1.21A4.34,4.34,0,0,1,91.43,405.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.09,341.08a30.08,30.08,0,0,1,.15-18.46c4.53,3.83,9.65,10.23,11.21,16a29.71,29.71,0,0,1-.61,17.51A30,30,0,0,1,38.09,341.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.67,331.57a6.1,6.1,0,0,0,.12,1c.09.64.26,1.57.49,2.71a72.75,72.75,0,0,0,5.9,17.18c.52,1,1,1.88,1.28,2.44a6.57,6.57,0,0,0,.52.87,5.32,5.32,0,0,0-.41-.93c-.28-.58-.69-1.43-1.17-2.48A90.7,90.7,0,0,1,44,344a88.5,88.5,0,0,1-2.49-8.71c-.27-1.13-.47-2.05-.6-2.69A6.71,6.71,0,0,0,40.67,331.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.17,312a30,30,0,0,0-11.77-14.22c-1.1,5.82-1,14,1.38,19.44A28.74,28.74,0,0,0,427,330.31,29.49,29.49,0,0,0,426.17,312Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.16,306.29a5.34,5.34,0,0,1,.55.85c.33.56.79,1.39,1.33,2.42a72.77,72.77,0,0,1,3.67,8.32,74.9,74.9,0,0,1,2.6,8.72c.26,1.14.44,2.06.55,2.71a6.36,6.36,0,0,1,.14,1,4.91,4.91,0,0,1-.27-1c-.15-.63-.37-1.54-.66-2.67a89.93,89.93,0,0,0-2.68-8.66c-1.23-3.32-2.55-6.25-3.57-8.33-.51-1.05-.93-1.89-1.23-2.46A6.73,6.73,0,0,1,418.16,306.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6,291.08a30,30,0,0,0-11.77-14.22c-1.09,5.83-1,14,1.38,19.44a29.76,29.76,0,0,0,11.53,13.21A30,30,0,0,0,443.6,291.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.6,285.33a5.75,5.75,0,0,1,.54.86c.34.55.79,1.38,1.33,2.41a72.73,72.73,0,0,1,6.27,17c.26,1.13.45,2.06.55,2.7a6.52,6.52,0,0,1,.14,1,5.58,5.58,0,0,1-.27-1c-.14-.64-.36-1.55-.65-2.68-.58-2.25-1.47-5.33-2.69-8.66a89.3,89.3,0,0,0-3.56-8.33c-.51-1-.93-1.88-1.23-2.46A5.45,5.45,0,0,1,435.6,285.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.12,295.25A30,30,0,0,1,484.65,301c-5,3.14-12.69,6-18.62,5.79a29.71,29.71,0,0,1-16.49-5.93A30.11,30.11,0,0,1,467.12,295.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.38,300.61a5.9,5.9,0,0,0-1-.19c-.64-.11-1.58-.24-2.73-.36a72,72,0,0,0-18.16.37c-1.15.17-2.08.33-2.72.47a6.21,6.21,0,0,0-1,.23,4.64,4.64,0,0,0,1-.1c.65-.1,1.58-.22,2.73-.37,2.3-.28,5.5-.57,9-.65s6.75.1,9.06.29c1.16.09,2.1.18,2.74.25A5.1,5.1,0,0,0,475.38,300.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.56,317a30.08,30.08,0,0,1,17.53,5.79c-5,3.14-12.69,6.06-18.62,5.79A29.78,29.78,0,0,1,434,322.68,30.05,30.05,0,0,1,451.56,317Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.82,322.39a4.35,4.35,0,0,0-1-.2c-.64-.11-1.58-.23-2.73-.36a73.67,73.67,0,0,0-9.09-.38,71.44,71.44,0,0,0-9.07.75c-1.15.17-2.08.33-2.72.47a4.52,4.52,0,0,0-1,.24,6.58,6.58,0,0,0,1-.11c.64-.1,1.58-.22,2.73-.36a90.49,90.49,0,0,1,9-.66c3.54-.06,6.75.1,9.06.29,1.16.09,2.1.18,2.74.25A5.84,5.84,0,0,0,459.82,322.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,341.24l.67-.37,1.87-1.15,1.35-.83c.49-.32,1-.69,1.56-1.07,1.11-.78,2.4-1.62,3.74-2.69l2.12-1.63c.74-.57,1.46-1.22,2.23-1.86,1.56-1.27,3.11-2.75,4.76-4.29a111.55,111.55,0,0,0,9.83-10.9,109.47,109.47,0,0,0,8.17-12.19c1.09-2,2.15-3.84,3-5.66.43-.91.88-1.77,1.26-2.62l1.06-2.46c.71-1.55,1.21-3,1.7-4.28.23-.63.46-1.22.65-1.77s.34-1.05.48-1.51c.28-.88.49-1.58.65-2.1a3.61,3.61,0,0,0,.2-.74,6.09,6.09,0,0,0-.28.72l-.74,2.06c-.15.46-.33,1-.51,1.5s-.45,1.12-.69,1.75c-.51,1.26-1,2.71-1.75,4.25-.35.77-.71,1.59-1.09,2.43s-.84,1.7-1.28,2.6c-.86,1.81-1.93,3.66-3,5.62a105.32,105.32,0,0,1-17.93,23c-1.64,1.54-3.17,3-4.72,4.3-.76.65-1.47,1.3-2.2,1.88l-2.1,1.65c-1.32,1.08-2.6,1.93-3.69,2.73-.55.39-1,.77-1.53,1.1l-1.33.86-1.82,1.22A4.34,4.34,0,0,0,411.85,341.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.19,276.56A30.08,30.08,0,0,0,465,258.1c-4.53,3.83-9.65,10.23-11.21,15.95a29.83,29.83,0,0,0,.6,17.52A30.05,30.05,0,0,0,465.19,276.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.61,267.05a6.21,6.21,0,0,1-.12,1c-.09.64-.26,1.57-.49,2.71A72.75,72.75,0,0,1,456.1,288c-.52,1-1,1.88-1.28,2.44a5.86,5.86,0,0,1-.53.87,6,6,0,0,1,.41-.93c.29-.58.69-1.43,1.18-2.49a90.36,90.36,0,0,0,3.39-8.41c1.14-3.35,2-6.45,2.49-8.71.27-1.13.47-2.05.6-2.69A5.4,5.4,0,0,1,462.61,267.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.78,263a36,36,0,0,1,17.12-14c-.05,7.11-2,16.74-6.09,22.57a34.43,34.43,0,0,1-16.2,12.78A35.4,35.4,0,0,1,206.78,263Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52,258.06a7.23,7.23,0,0,0-.84.88c-.52.58-1.24,1.44-2.11,2.54a86.63,86.63,0,0,0-11.29,18.62c-.57,1.27-1,2.32-1.27,3a8.14,8.14,0,0,0-.4,1.15,6.39,6.39,0,0,0,.54-1.09c.32-.71.79-1.74,1.39-3a108.25,108.25,0,0,1,5.14-9.58c2.21-3.63,4.43-6.77,6.11-9,.84-1.11,1.53-2,2-2.61A6.43,6.43,0,0,0,217.52,258.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,234.32a36.1,36.1,0,0,1,17.11-14c-.05,7.11-2,16.74-6.08,22.57a35.72,35.72,0,0,1-16.59,12.89A36,36,0,0,1,191.08,234.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.82,229.4a6.36,6.36,0,0,0-.84.88c-.52.58-1.25,1.44-2.12,2.54a89.22,89.22,0,0,0-6.23,9,88,88,0,0,0-5.06,9.66c-.56,1.28-1,2.33-1.27,3.06a5.81,5.81,0,0,0-.39,1.15,6.39,6.39,0,0,0,.54-1.09c.32-.71.79-1.74,1.38-3,1.2-2.52,2.95-5.95,5.15-9.58a107.61,107.61,0,0,1,6.11-9c.84-1.11,1.53-2,2-2.61A7.13,7.13,0,0,0,201.82,229.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45,233.84a36,36,0,0,0-21.95,2.78c5.2,4.85,13.54,10,20.57,11.09a35.65,35.65,0,0,0,20.76-3.19A35.9,35.9,0,0,0,162.45,233.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49,238.25a6.79,6.79,0,0,1,1.22,0c.78,0,1.91.09,3.3.21a88.25,88.25,0,0,1,10.78,1.63,89.69,89.69,0,0,1,10.5,3c1.32.47,2.37.87,3.09,1.18a7.91,7.91,0,0,1,1.1.5,6.24,6.24,0,0,1-1.16-.36c-.73-.25-1.8-.62-3.12-1.05-2.65-.86-6.34-1.94-10.49-2.84A108.39,108.39,0,0,0,156,238.74c-1.38-.16-2.51-.27-3.28-.34A6.8,6.8,0,0,1,151.49,238.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.77,263a36,36,0,0,0-22,2.78c5.2,4.85,13.54,10,20.57,11.09a35.61,35.61,0,0,0,20.77-3.19A36,36,0,0,0,175.77,263Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,267.44a6.25,6.25,0,0,1,1.21,0c.78,0,1.91.08,3.3.2a86.91,86.91,0,0,1,21.28,4.6c1.32.47,2.37.87,3.09,1.18a7.22,7.22,0,0,1,1.1.5,6.38,6.38,0,0,1-1.15-.35l-3.13-1.06c-2.65-.86-6.34-1.94-10.49-2.84a107.92,107.92,0,0,0-10.73-1.74c-1.38-.16-2.5-.27-3.28-.34A6.38,6.38,0,0,1,164.81,267.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,300.63a5.61,5.61,0,0,1-.7-.59l-1.94-1.77-1.4-1.3c-.5-.48-1-1-1.59-1.61-1.12-1.17-2.45-2.46-3.78-4-.68-.77-1.39-1.57-2.12-2.41s-1.44-1.77-2.2-2.7c-1.54-1.85-3-4-4.62-6.13A134.34,134.34,0,0,1,189.52,265a132.88,132.88,0,0,1-6.82-16.22c-.82-2.58-1.65-5-2.23-7.35-.3-1.16-.63-2.28-.88-3.37l-.69-3.13c-.47-2-.73-3.83-1-5.43-.13-.8-.26-1.55-.36-2.24s-.15-1.31-.22-1.89c-.12-1.09-.21-2-.29-2.61a7,7,0,0,1-.06-.92,5.27,5.27,0,0,1,.17.91c.1.64.23,1.5.39,2.6.08.57.17,1.19.27,1.88s.26,1.42.4,2.22c.31,1.59.59,3.41,1.09,5.39L180,238c.26,1.08.6,2.19.91,3.35.6,2.32,1.43,4.75,2.26,7.31A139.47,139.47,0,0,0,190,264.77a141,141,0,0,0,9,15c1.58,2.18,3,4.29,4.56,6.14.75.94,1.44,1.87,2.17,2.71l2.09,2.42c1.3,1.58,2.61,2.88,3.71,4.07.56.58,1.07,1.14,1.55,1.64l1.36,1.32L216.3,300A6.49,6.49,0,0,1,216.93,300.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,212.29a36,36,0,0,1,4.42-21.69c4.45,5.55,9,14.25,9.52,21.34a35.59,35.59,0,0,1-4.73,20.47A36,36,0,0,1,169,212.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.23,201.69a6.54,6.54,0,0,0-.09,1.21c0,.78-.06,1.91,0,3.3a86.69,86.69,0,0,0,3,21.57c.36,1.35.69,2.43.94,3.17a6.11,6.11,0,0,0,.42,1.14,7.88,7.88,0,0,0-.27-1.19c-.2-.75-.49-1.84-.82-3.19-.66-2.71-1.46-6.47-2.05-10.68s-.84-8-.94-10.82c0-1.39-.07-2.52-.08-3.3A6.85,6.85,0,0,0,174.23,201.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,219.7a36.1,36.1,0,0,0-17.11-14c0,7.11,2,16.74,6.08,22.57A34.41,34.41,0,0,0,279.5,241,35.37,35.37,0,0,0,274.33,219.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.59,214.78a6.36,6.36,0,0,1,.84.88c.52.58,1.25,1.44,2.12,2.54a88,88,0,0,1,11.29,18.61c.56,1.28,1,2.32,1.27,3.06a7.31,7.31,0,0,1,.39,1.14,5.55,5.55,0,0,1-.54-1.08c-.32-.71-.79-1.74-1.38-3-1.2-2.51-2.95-5.94-5.15-9.57s-4.43-6.77-6.11-9c-.84-1.11-1.53-2-2-2.61A8,8,0,0,1,263.59,214.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,191a36,36,0,0,0-17.11-14c.05,7.11,2,16.73,6.08,22.57a35.67,35.67,0,0,0,16.6,12.88A36,36,0,0,0,290,191Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,186.12a6.8,6.8,0,0,1,.83.88c.52.58,1.25,1.44,2.12,2.53a87.29,87.29,0,0,1,11.29,18.62c.57,1.28,1,2.32,1.27,3.06a6.15,6.15,0,0,1,.39,1.14,7.72,7.72,0,0,1-.53-1.08c-.32-.71-.79-1.74-1.39-3-1.19-2.51-2.95-5.94-5.15-9.57a107.61,107.61,0,0,0-6.11-9c-.83-1.11-1.53-2-2-2.61A6.13,6.13,0,0,1,279.3,186.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,190.55a36,36,0,0,1,22,2.79c-5.2,4.85-13.54,10-20.58,11.09a35.65,35.65,0,0,1-20.76-3.19A36,36,0,0,1,318.66,190.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.62,195a6.65,6.65,0,0,0-1.21,0c-.78,0-1.91.09-3.3.21a86.19,86.19,0,0,0-10.79,1.63,87.77,87.77,0,0,0-10.5,3c-1.31.47-2.37.87-3.09,1.18a6.66,6.66,0,0,0-1.1.5,6.24,6.24,0,0,0,1.16-.36c.73-.26,1.8-.62,3.13-1.05,2.64-.86,6.34-1.94,10.49-2.84s8-1.44,10.72-1.75c1.39-.15,2.51-.26,3.29-.33A8.21,8.21,0,0,0,329.62,195Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.35,219.74a36.07,36.07,0,0,1,21.95,2.79c-5.19,4.85-13.54,10-20.57,11.09A35.65,35.65,0,0,1,286,230.43,36,36,0,0,1,305.35,219.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.31,224.16a6.79,6.79,0,0,0-1.22,0c-.78,0-1.91.09-3.3.21A86.34,86.34,0,0,0,301,226a89.69,89.69,0,0,0-10.5,3c-1.31.47-2.37.87-3.09,1.18a7.91,7.91,0,0,0-1.1.5,6.24,6.24,0,0,0,1.16-.36c.73-.25,1.8-.62,3.12-1.05,2.65-.86,6.34-1.94,10.49-2.84s8-1.44,10.73-1.74c1.39-.16,2.51-.27,3.28-.34A6.8,6.8,0,0,0,316.31,224.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,257.35a5.61,5.61,0,0,0,.7-.59l1.95-1.78,1.39-1.29c.5-.48,1-1,1.59-1.61,1.12-1.17,2.46-2.46,3.78-4l2.13-2.41c.73-.84,1.43-1.77,2.19-2.7,1.55-1.85,3-3.95,4.62-6.14a134.16,134.16,0,0,0,9.06-15.08,132.88,132.88,0,0,0,6.82-16.22c.83-2.58,1.65-5,2.23-7.35.3-1.17.64-2.28.88-3.37l.69-3.14c.47-2,.73-3.82,1-5.42.13-.8.27-1.55.36-2.24s.16-1.31.22-1.89c.12-1.1.22-2,.29-2.61a5.28,5.28,0,0,0,.06-.92,5.26,5.26,0,0,0-.17.9c-.1.65-.23,1.51-.39,2.6-.08.57-.17,1.2-.26,1.88s-.27,1.43-.41,2.23c-.31,1.59-.59,3.41-1.09,5.39l-.72,3.12c-.25,1.08-.6,2.19-.91,3.35-.59,2.32-1.43,4.74-2.26,7.31a126.69,126.69,0,0,1-15.82,31.18c-1.57,2.18-3,4.29-4.56,6.14-.75.93-1.44,1.86-2.17,2.71l-2.09,2.42c-1.3,1.57-2.61,2.88-3.71,4.07-.56.58-1.06,1.14-1.55,1.64l-1.36,1.32-1.87,1.85A6.49,6.49,0,0,0,264.18,257.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,169a36,36,0,0,0-4.42-21.69c-4.45,5.54-9,14.25-9.52,21.34a35.67,35.67,0,0,0,4.73,20.47A36,36,0,0,0,312.1,169Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,158.41a6.82,6.82,0,0,1,.1,1.21c0,.78,0,1.91,0,3.3a87.6,87.6,0,0,1-.83,10.88A89,89,0,0,1,304,184.49c-.37,1.35-.69,2.43-.94,3.17a9.5,9.5,0,0,1-.42,1.14,7,7,0,0,1,.26-1.19c.21-.75.49-1.84.82-3.19.66-2.71,1.46-6.47,2.05-10.68s.84-8,.94-10.83c0-1.39.08-2.51.09-3.29A6.43,6.43,0,0,1,306.88,158.41Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.36,454.11c0,.15-104.49.26-233.35.26s-233.37-.11-233.37-.26,104.46-.26,233.37-.26S483.36,454,483.36,454.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 452.8,
    cy: 138.23,
    r: 21.66,
    transform: "translate(215.12 547.67) rotate(-76.84)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.45,138.23a2,2,0,0,1,0-.35c0-.26-.05-.6-.08-1,0-.22,0-.48-.05-.75s-.09-.58-.14-.9a16.45,16.45,0,0,0-.46-2.23,20.85,20.85,0,0,0-2.41-5.72,21.45,21.45,0,0,0-25.77-9.13,22.13,22.13,0,0,0-2.79,1.23,22.91,22.91,0,0,0-2.63,1.68,23.63,23.63,0,0,0-2.42,2.07,25,25,0,0,0-2.1,2.48,21.07,21.07,0,0,0-3.06,5.9,23,23,0,0,0-1.1,6.75,22.77,22.77,0,0,0,1.1,6.75,20.81,20.81,0,0,0,3.06,5.9,25,25,0,0,0,2.1,2.48,23.63,23.63,0,0,0,2.42,2.07,24.45,24.45,0,0,0,2.63,1.69,22.06,22.06,0,0,0,2.79,1.22,21.49,21.49,0,0,0,25.77-9.13,20.85,20.85,0,0,0,2.41-5.72,16.65,16.65,0,0,0,.46-2.22c.05-.33.11-.63.14-.91s0-.52.05-.75c0-.43.06-.77.08-1a2,2,0,0,1,0-.35,1.88,1.88,0,0,1,0,.35c0,.26,0,.6,0,1,0,.23,0,.49,0,.77s-.08.58-.12.91a15,15,0,0,1-.42,2.25,20.6,20.6,0,0,1-2.35,5.82,21.85,21.85,0,0,1-14.69,10.36,22,22,0,0,1-11.49-.92,20.15,20.15,0,0,1-5.55-3,26,26,0,0,1-2.49-2.11,25.07,25.07,0,0,1-2.15-2.54,21,21,0,0,1-3.14-6,23.15,23.15,0,0,1-1.13-6.91,23.54,23.54,0,0,1,1.13-6.92,21.11,21.11,0,0,1,3.14-6,25.07,25.07,0,0,1,2.15-2.54,26,26,0,0,1,2.49-2.11,25.49,25.49,0,0,1,2.69-1.72,22.46,22.46,0,0,1,2.86-1.24,21.78,21.78,0,0,1,26.18,9.43,20.72,20.72,0,0,1,2.35,5.82,15.21,15.21,0,0,1,.42,2.25c0,.33.09.64.12.92s0,.53,0,.76c0,.43,0,.77,0,1A1.88,1.88,0,0,1,474.45,138.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.62,148.16A3.66,3.66,0,1,1,424,144.5,3.65,3.65,0,0,1,427.62,148.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.62,148.16c-.05,0-.05-.33-.21-.87a3.63,3.63,0,0,0-1.35-1.89,3.47,3.47,0,0,0-3.26-.45,3.43,3.43,0,0,0,0,6.42,3.47,3.47,0,0,0,3.26-.45,3.67,3.67,0,0,0,1.35-1.89c.16-.55.16-.87.21-.87a1.83,1.83,0,0,1,0,.91,3.59,3.59,0,0,1-1.31,2.14,3.82,3.82,0,0,1-3.65.61,3.88,3.88,0,0,1,0-7.32,3.82,3.82,0,0,1,3.65.6,3.59,3.59,0,0,1,1.31,2.14A1.88,1.88,0,0,1,427.62,148.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.8,145.39a3,3,0,0,1,6,0,3,3,0,0,1-6,0Zm0-15.92h6l-1,11.73h-4Z",
    style: {
      fill: "#38BDF8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 209.59,
    cy: 77.3,
    r: 23.31,
    transform: "translate(6.73 170.84) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,77.3a2.91,2.91,0,0,1-.05-.38c0-.27,0-.64-.08-1.1,0-.25,0-.52-.05-.81s-.1-.63-.15-1a18.47,18.47,0,0,0-.5-2.4,22.18,22.18,0,0,0-2.59-6.16,23.13,23.13,0,0,0-27.75-9.84,24.2,24.2,0,0,0-3,1.33,23.71,23.71,0,0,0-2.82,1.82A24.82,24.82,0,0,0,193.28,61,27.7,27.7,0,0,0,191,63.67,22.33,22.33,0,0,0,187.73,70a22.8,22.8,0,0,0,0,14.54A22.33,22.33,0,0,0,191,90.93a26.34,26.34,0,0,0,2.26,2.67,27.25,27.25,0,0,0,2.61,2.23,26.64,26.64,0,0,0,2.83,1.82,24.13,24.13,0,0,0,3,1.32,23.18,23.18,0,0,0,27.75-9.84A22.18,22.18,0,0,0,232.07,83a18.47,18.47,0,0,0,.5-2.4c.05-.35.12-.68.15-1l.05-.82c0-.46.06-.83.08-1.1a2.91,2.91,0,0,1,.05-.38,2.21,2.21,0,0,1,0,.38l0,1.11,0,.82c0,.3-.08.63-.13,1a16.54,16.54,0,0,1-.45,2.43,22.17,22.17,0,0,1-2.54,6.26,23.41,23.41,0,0,1-28.16,10.14,24.53,24.53,0,0,1-3.08-1.34,24,24,0,0,1-2.89-1.85A27.28,27.28,0,0,1,192.92,94a29,29,0,0,1-2.31-2.73,22.91,22.91,0,0,1-3.38-6.49,23.39,23.39,0,0,1,0-14.88,22.89,22.89,0,0,1,3.37-6.49,29,29,0,0,1,2.31-2.73,25.86,25.86,0,0,1,2.68-2.26,24,24,0,0,1,2.89-1.85,24.6,24.6,0,0,1,3.08-1.35,23.6,23.6,0,0,1,12.36-1,23.55,23.55,0,0,1,15.8,11.13,22.29,22.29,0,0,1,2.54,6.26,16.54,16.54,0,0,1,.45,2.43c.05.36.1.68.13,1s0,.58,0,.82l0,1.11A2.21,2.21,0,0,1,232.9,77.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.69,77.32A2.3,2.3,0,1,1,200.4,75,2.29,2.29,0,0,1,202.69,77.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.89,77.32a2.3,2.3,0,1,1-2.3-2.3A2.3,2.3,0,0,1,211.89,77.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.06,76.17a2.3,2.3,0,1,1-3.14-.84A2.3,2.3,0,0,1,221.06,76.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,106a3.94,3.94,0,1,1-3.93-3.94A3.94,3.94,0,0,1,223.64,106Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,106s0-.35-.22-.94a3.93,3.93,0,0,0-1.45-2,3.71,3.71,0,1,0,0,6,4,4,0,0,0,1.44-2c.17-.59.17-.94.22-.94a2.17,2.17,0,0,1,0,1,4,4,0,0,1-1.42,2.29,4.12,4.12,0,0,1-3.92.64,4.16,4.16,0,0,1,0-7.84,4.1,4.1,0,0,1,3.92.65,3.91,3.91,0,0,1,1.42,2.28A2.17,2.17,0,0,1,223.64,106Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.27,
    cy: 164.04,
    r: 21.66,
    transform: "translate(-114.94 181.52) rotate(-76.21)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.92,164a2,2,0,0,1,0-.35c0-.26,0-.59-.08-1l0-.76c0-.28-.09-.58-.14-.9a16.77,16.77,0,0,0-.46-2.23,20.85,20.85,0,0,0-2.41-5.72A21.45,21.45,0,0,0,51,143.93a22.13,22.13,0,0,0-2.79,1.23,21.71,21.71,0,0,0-2.63,1.69,22.35,22.35,0,0,0-2.42,2.06,25,25,0,0,0-2.1,2.48,21.07,21.07,0,0,0-3.06,5.9,21.26,21.26,0,0,0,0,13.5,20.68,20.68,0,0,0,3.06,5.9,22.91,22.91,0,0,0,2.1,2.48,23.63,23.63,0,0,0,2.42,2.07,21.71,21.71,0,0,0,2.63,1.69A23.67,23.67,0,0,0,51,184.16a21.59,21.59,0,0,0,11.25.94,21.31,21.31,0,0,0,9-4A21.64,21.64,0,0,0,76.74,175a21.11,21.11,0,0,0,2.41-5.72,17.09,17.09,0,0,0,.46-2.23c0-.33.11-.63.14-.9l0-.76c0-.43.06-.77.08-1a2,2,0,0,1,0-.35,1.88,1.88,0,0,1,0,.35l0,1c0,.23,0,.48,0,.76s-.08.58-.12.91a15,15,0,0,1-.42,2.25A20.65,20.65,0,0,1,77,175.18,21.88,21.88,0,0,1,62.3,185.53a22,22,0,0,1-11.49-.92,20.15,20.15,0,0,1-5.55-3,24.61,24.61,0,0,1-2.49-2.11A24,24,0,0,1,40.62,177a21.11,21.11,0,0,1-3.14-6A23.21,23.21,0,0,1,36.35,164a23.47,23.47,0,0,1,1.13-6.91,21,21,0,0,1,3.14-6,25,25,0,0,1,2.15-2.53,24.61,24.61,0,0,1,2.49-2.11A22.64,22.64,0,0,1,48,144.73a21.19,21.19,0,0,1,2.86-1.25,21.86,21.86,0,0,1,11.49-.92A21.8,21.8,0,0,1,77,152.91a20.72,20.72,0,0,1,2.35,5.82,15.09,15.09,0,0,1,.42,2.26c0,.33.1.63.12.91s0,.53,0,.76l0,1A1.88,1.88,0,0,1,79.92,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.61,163a5.29,5.29,0,0,0-1.34-2.9,5.2,5.2,0,0,0-2.65-1.66,4.13,4.13,0,0,0-4.56,2.09,4.12,4.12,0,0,0-1.22-1.34,4.22,4.22,0,0,0-3.22-.65A5.06,5.06,0,0,0,51,160.2a5.27,5.27,0,0,0-1.39,2.88,6.44,6.44,0,0,0,.77,4,9.24,9.24,0,0,0,3.14,3c2.05,1.25,4.75,2.83,4.75,2.83s2.31-1.7,4.38-2.93A9.22,9.22,0,0,0,65.78,167,6.42,6.42,0,0,0,66.61,163Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,180.46a3.66,3.66,0,1,1-3.66-3.66A3.65,3.65,0,0,1,86.4,180.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,180.46c-.05,0-.05-.33-.22-.87a3.6,3.6,0,0,0-1.34-1.89,3.43,3.43,0,1,0,0,5.52,3.62,3.62,0,0,0,1.34-1.9c.17-.54.17-.86.22-.86a1.82,1.82,0,0,1,0,.91,3.67,3.67,0,0,1-1.32,2.14,3.82,3.82,0,0,1-3.65.61,3.88,3.88,0,0,1,0-7.32,3.82,3.82,0,0,1,3.65.6,3.67,3.67,0,0,1,1.32,2.14A1.88,1.88,0,0,1,86.4,180.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2-and-3--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 404.49,
    width: 414.62,
    height: 49.46,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 410.67,
    width: 407.86,
    height: 36.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 404.49,
    width: 80.57,
    height: 49.46,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.29,418.74l-1.05,0-3.09,0-11.9,0-43.75.08L262.16,419l-144.37-.08L74,418.84l-11.89,0-3.09,0-1.06,0,1.06,0,3.09,0L74,418.64l43.75-.08,144.37-.08,144.34.08,43.75.08,11.9.05,3.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.29,428.61s-.35,0-1.05,0l-3.09,0-11.9,0-43.75.08-144.34.08-144.37-.08L74,428.71l-11.89,0-3.09,0c-.7,0-1.06,0-1.06,0l1.06,0,3.09,0L74,428.51l43.75-.09,144.37-.07,144.34.07,43.75.09,11.9.05,3.09,0C465.94,428.59,466.29,428.61,466.29,428.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.29,438.48l-1.05,0-3.09,0-11.9.05-43.75.08-144.34.08-144.37-.08L74,438.58l-11.89-.05-3.09,0-1.06,0,1.06,0,3.09,0L74,438.37l43.75-.08,144.37-.07,144.34.07,43.75.08,11.9.05,3.09,0C465.94,438.46,466.29,438.48,466.29,438.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,453.13c-.15,0-.26-10.77-.26-24s.11-24,.26-24,.26,10.76.26,24S392.87,453.13,392.73,453.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.98,
    y: 358.73,
    width: 286.74,
    height: 45.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.65,
    y: 359,
    width: 78.03,
    height: 45.23,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.99,
    y: 365.19,
    width: 70.69,
    height: 32.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.65,
    y: 359,
    width: 78.03,
    height: 45.23,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,394.46s0-.44,0-1.27,0-2.06,0-3.67c0-3.24,0-8-.07-14.2l.11.11-195.08.15h0l.26-.26v19.14l-.26-.26,138.52.11,41.43.07,11.22,0,2.92,0c.66,0,1,0,1,0h-1l-2.88,0-11.17,0-41.36.07-138.71.12h-.26V375.06h.27l195.08.15h.11v.11c0,6.22,0,11-.06,14.26,0,1.6,0,2.82,0,3.65S339.67,394.46,339.67,394.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,404.19c-.15,0-.26-10.25-.26-22.9s.11-22.9.26-22.9.26,10.25.26,22.9S360.89,404.19,360.75,404.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.32,
    y: 305.32,
    width: 286.74,
    height: 35.81,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75,334.07a2.45,2.45,0,0,1,0-.41c0-.31,0-.68,0-1.15,0-1,0-2.46-.06-4.24,0-3.65-.07-8.72-.12-14.68l.24.24-13.58,0,.26-.26h0v5.65c0,1.84,0,3.63,0,5.35,0,3.45,0,6.63,0,9.46l-.21-.21L329,334l2.75,0a8.48,8.48,0,0,1,1,.05,7.62,7.62,0,0,1-.92,0l-2.7.06-10,.11H319v-.21c0-2.83,0-6,0-9.46,0-1.72,0-3.51,0-5.35v-5.65h0l.26-.26,13.58,0H333v.24c-.05,6-.09,11.15-.12,14.84,0,1.75-.05,3.16-.07,4.19,0,.44,0,.8,0,1.09A1.44,1.44,0,0,1,332.75,334.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.83,
    y: 310.93,
    width: 44.23,
    height: 24.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 305.32,
    width: 50.05,
    height: 35.81,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.79,340.92c-.15,0-.26-7.9-.26-17.65s.11-17.65.26-17.65.26,7.9.26,17.65S345.93,340.92,345.79,340.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,316.66c0,.14-10.05.26-22.45.26s-22.45-.12-22.45-.26,10.05-.26,22.45-.26S396.39,316.51,396.39,316.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,323c0,.15-10.05.26-22.45.26s-22.45-.11-22.45-.26,10.05-.26,22.45-.26S396.39,322.89,396.39,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,329.5c0,.14-10.05.26-22.45.26s-22.45-.12-22.45-.26,10.05-.26,22.45-.26S396.39,329.35,396.39,329.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.52,
    y: 341.13,
    width: 286.74,
    height: 17.67,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 343.35,
    width: 64.1,
    height: 13.38,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.53,
    y: 341.13,
    width: 67.72,
    height: 17.67,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.53,358.8a70.88,70.88,0,0,1-.24-8.5,68.94,68.94,0,0,1,.29-8.5,69.64,69.64,0,0,1,.23,8.5A70.4,70.4,0,0,1,377.53,358.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.13,
    y: 347.94,
    width: 172.69,
    height: 4.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.56,358.66c0,.15-47.52.26-106.12.26s-106.13-.11-106.13-.26,47.51-.26,106.13-.26S370.56,358.52,370.56,358.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.24,358.75c0,.14-47.52.26-106.12.26S166,358.89,166,358.75s47.51-.26,106.13-.26S378.24,358.6,378.24,358.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.26,341c0,.15-62.53.26-139.63.26S166,341.15,166,341s62.51-.26,139.64-.26S445.26,340.86,445.26,341Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,305.19l-1.77,23.5s22,9.72,22.12,14.09L392,340.93l1.34-36.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,326.13a1.89,1.89,0,0,0-1.32,2.08,1.71,1.71,0,0,0,1.94,1.38,2,2,0,0,0,1.38-2.2,1.75,1.75,0,0,0-2.17-1.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,340.93l.27-3.7,41.43,3.16s1.89,1,1.62,2.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.86,328.48c0,.23-1.08.28-2.15,1s-1.66,1.58-1.85,1.49.17-1.38,1.48-2.17S413.91,328.28,413.86,328.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.32,330.66c0,.22-.89.56-1.65,1.47s-1,1.9-1.22,1.88-.29-1.28.67-2.4S418.32,330.45,418.32,330.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.66,336.51c-.19,0-.44-1.09.15-2.29s1.61-1.64,1.69-1.45-.56.81-1,1.81S420.87,336.49,420.66,336.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.7,323.08c-.1.2-1.05-.15-2.25-.11s-2.15.39-2.25.19.82-1,2.24-1S413.81,322.91,413.7,323.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.33,227.59c13-2.25,27.66,10.49,25.37,27-2,14.45-14.9,67.25-14.9,67.25L397.9,311.7l5.9-65.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.39 304.2 394.67 279.64 395.39 267.84 353.39 304.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67,265.31l-2.2,7.9c-3.34,12-1.23,22.46,6.53,32.24h.25l38.79.3c11.09-4.84,42.92-34.87,42.92-34.87l-3.49,52,28.1,2.16s4-56.81,6.18-70.24-5.38-27.29-16.65-26.32S308.28,263.12,307.67,265.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,228.46a.9.9,0,0,1,.26,0l.75,0a11.74,11.74,0,0,1,2.88.47,18.2,18.2,0,0,1,8.57,6.24,20.63,20.63,0,0,1,3.56,6.48,29.62,29.62,0,0,1,1.42,8.37,79.91,79.91,0,0,1-.58,9.35c-.31,3.23-.63,6.57-1,10-1.41,13.66-2.69,26-3.63,35-.43,4.45-.77,8.07-1,10.62-.12,1.22-.21,2.19-.28,2.89q0,.45-.09.75a1,1,0,0,1,0,.25,1,1,0,0,1,0-.26c0-.2,0-.45,0-.75,0-.7.1-1.67.18-2.9.18-2.51.46-6.15.86-10.63.78-9,2.09-21.36,3.47-35,.33-3.42.66-6.76,1-10a82.1,82.1,0,0,0,.6-9.28,29.37,29.37,0,0,0-1.35-8.25,20.09,20.09,0,0,0-3.44-6.39,18.2,18.2,0,0,0-8.34-6.27A13.57,13.57,0,0,0,408.1,228.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.94,258.32c.11.12-2.64,2.63-5.26,6.37s-4.08,7.16-4.23,7.09a9.55,9.55,0,0,1,.85-2.29,33.37,33.37,0,0,1,3-5.1,32.65,32.65,0,0,1,3.81-4.5A9,9,0,0,1,402.94,258.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.61,148.55a4.59,4.59,0,0,0,4.78-7.79,4.78,4.78,0,0,0-1.27-9,5.73,5.73,0,0,0-6.6-7.28,6.43,6.43,0,0,0-7.43-2.76,4.57,4.57,0,0,0-6.37,6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.66,125.68l1,.34A19.49,19.49,0,0,1,409,149.38c-2.4,9.14-5.17,19.21-6.91,24-3.59,9.84-14,7.91-14,7.91l-3.33,12.16-23.71-9.16,13-43.78C376.77,129.9,385.18,122.68,395.66,125.68Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19,181.26a25.34,25.34,0,0,1-11.61-8.33s.58,8.59,10.75,11.16Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.06,158.58a1.51,1.51,0,0,1-1.86.95,1.44,1.44,0,0,1-1-1.79,1.5,1.5,0,0,1,1.86-.94A1.43,1.43,0,0,1,402.06,158.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,153.47c-.24.12-1-1.05-2.55-1.57s-2.89-.16-3-.41.24-.38.85-.56A4.1,4.1,0,0,1,403,151a4,4,0,0,1,1.95,1.49C405.28,153,405.32,153.42,405.2,153.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,154.88a1.5,1.5,0,0,1-1.86.94,1.43,1.43,0,0,1-1-1.78,1.51,1.51,0,0,1,1.86-.95A1.43,1.43,0,0,1,389.47,154.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.18,148.51c-.24.13-1-1-2.55-1.57s-2.89-.16-3-.4.24-.38.85-.56a4.1,4.1,0,0,1,2.48.09,4.05,4.05,0,0,1,1.95,1.48C390.26,148.07,390.3,148.46,390.18,148.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.74,161.7a11.15,11.15,0,0,1,2.62.42c.41.1.8.15,1-.09a2.09,2.09,0,0,0,.14-1.24c0-1.06-.07-2.18-.11-3.35-.12-4.76-.06-8.62.14-8.63s.44,3.86.56,8.62c0,1.17,0,2.29.05,3.35a2.39,2.39,0,0,1-.33,1.59,1,1,0,0,1-.84.35,3.11,3.11,0,0,1-.69-.14A10.38,10.38,0,0,1,391.74,161.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.55,143.14c-.33.31-1.49-.56-3.07-1.18s-3-.82-3-1.27c0-.21.41-.46,1.09-.56a5,5,0,0,1,2.58.34,4.79,4.79,0,0,1,2.07,1.52C393.6,142.53,393.7,143,393.55,143.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.47,147.23c-.44.24-1.56-.56-3.07-1.11s-2.86-.74-3-1.2c-.06-.22.26-.5.93-.63a5.2,5.2,0,0,1,2.7.31,5.08,5.08,0,0,1,2.22,1.56C407.62,146.7,407.67,147.12,407.47,147.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,144.52s-.43-7.1-2.91-9.59c-3-3-5.94.4-9-1.77s-6-5-10.42-3.63c-4.87,1.56-3.78,4.24-5.56,8.54-7.2,17.43-12.2,21.31-10.19,12.62.22-.95-2.07-2.58-1.09-6.58,1.28-5.2,3.23-11.36,5.6-14.54,2-2.67,4.44-4.14,8.31-5.35,6.12-1.92,12.81.34,17.17,2.39S412.79,136.92,409.66,144.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,150.64a2.83,2.83,0,0,0-2-3.6c-1.91-.47-4.32-.14-5.54,3.7-2.15,6.83,5.15,7.59,5.22,7.4S371.39,153.51,372.26,150.64Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.28,155.1s-.14,0-.37.07a1.24,1.24,0,0,1-.9-.26,3.09,3.09,0,0,1-.52-3.07,3.93,3.93,0,0,1,.87-1.6,1.44,1.44,0,0,1,1.18-.63.64.64,0,0,1,.6.55c0,.22-.06.34,0,.36s.19-.06.22-.36a.78.78,0,0,0-.13-.52.94.94,0,0,0-.6-.38,1.76,1.76,0,0,0-1.58.67,4.22,4.22,0,0,0-1,1.77c-.39,1.39-.1,2.9.8,3.5a1.32,1.32,0,0,0,1.15.16C369.22,155.26,369.3,155.12,369.28,155.1Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,137.6a6.75,6.75,0,0,0,2.39,2.33,2.35,2.35,0,0,0,3-.69c.25-.45.32-1,.76-1.29s1.15.07,1.7.33c1.89.9,4.94-.46,6.11-2.2a1.88,1.88,0,0,0,2.19,1.32,6.86,6.86,0,0,0,2.13-.88,3,3,0,0,1,2.73-.34c.47.24.83.7,1.35.83.92.24,1.71-.65,2.16-1.48s.9-1.83,1.82-2a3.72,3.72,0,0,1,2.44.78c.77.41,1.9.58,2.38-.14a1.66,1.66,0,0,0,.13-1.33,4.63,4.63,0,0,0-4.58-3.47,6.28,6.28,0,0,0-10.49-5,6.37,6.37,0,0,0-10.38-1.18,4.63,4.63,0,0,0-7.15,4.62,4.39,4.39,0,0,0-3.43,2.49c-.52,1.39.36,3.26,1.83,3.37a2.56,2.56,0,0,0,3.34,3.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.5,131.49a.44.44,0,0,1-.05.13,2.64,2.64,0,0,1-.17.34,4.43,4.43,0,0,1-.95,1.13,5,5,0,0,1-2.05,1.07,4.77,4.77,0,0,1-3-.18l.17-.11a2.57,2.57,0,0,1-.79,1.82,7.15,7.15,0,0,1-1.74,1.25,4.71,4.71,0,0,1-1,.51,2.66,2.66,0,0,1-3.11-1.52l.28,0a5.36,5.36,0,0,1-3.38,2.75,3.94,3.94,0,0,1-2.47,0,7,7,0,0,1-2-1.25h.2a5.55,5.55,0,0,1-2.33,1.52,3,3,0,0,1-2.57-.19,3.94,3.94,0,0,1-1.85-3.91l.13.12a3.66,3.66,0,0,1-2.44-.47,4,4,0,0,1-1.36-1.29,3.53,3.53,0,0,1-.47-1.09,1.6,1.6,0,0,1,0-.41,4.66,4.66,0,0,0,.62,1.43,4,4,0,0,0,1.35,1.21,3.56,3.56,0,0,0,2.31.41l.15,0,0,.15a3.73,3.73,0,0,0,1.76,3.65,2.71,2.71,0,0,0,2.35.14,5.36,5.36,0,0,0,2.2-1.45l.1-.1.11.09a6.84,6.84,0,0,0,1.93,1.19,3.62,3.62,0,0,0,2.28,0,5.06,5.06,0,0,0,3.19-2.59l.16-.3.12.32a2.32,2.32,0,0,0,1.68,1.36,2.27,2.27,0,0,0,1.07,0,5.06,5.06,0,0,0,1-.48,6.9,6.9,0,0,0,1.69-1.19,2.33,2.33,0,0,0,.74-1.64v-.18l.17.07a4.6,4.6,0,0,0,2.9.22,5.09,5.09,0,0,0,2-1A5.88,5.88,0,0,0,403.5,131.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,166.74c0-.26-1.75-.43-2.88-2.08s-.76-3.54-1-3.57-.39.39-.48,1.19a4.5,4.5,0,0,0,.74,3,3.88,3.88,0,0,0,2.43,1.63C389.5,167,390,166.87,390,166.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.48,173.36s-17-.88-24.58,8.43C333.23,190,304,262.38,304,274.19s26.26,1.53,36.46-3.84S379.1,239.2,379.1,239.2s.48-3.1,1-5.78,5.32-21.24,5.88-27.78c.43-5.07-.44-16.11-.44-16.11C375.33,187.63,364.48,173.36,364.48,173.36Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.37 211.71 458.26 211.08 457.45 211.28 446.97 190.94 398.93 211.65 414.04 231.22 458.37 211.71",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "432.62 219.11 425.12 205.71 440.56 198.88 448.5 212.71 432.62 219.11",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.58,225.17l8.71-4.48s5.08-11.75,8.31-13.85,8.29-1.21,8.29-1.21l-4.61,3.44s-3.07,4.16-.12,4.82,18.33-6.92,20.48-6.7-.1,4.09-.1,4.09,2.89.84.34,4.39A4.91,4.91,0,0,1,427,220.1c-5.76,4.15-17.53,8.73-18.76,9.45-1.72,1-15.74,8.53-15.74,8.53Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.54,211.28a7.12,7.12,0,0,1-1.57,1.2c-1,.69-2.43,1.6-4.06,2.51a37.87,37.87,0,0,1-4.31,2.09,6.83,6.83,0,0,1-1.89.6c0-.15,2.72-1.32,6-3.14A62.43,62.43,0,0,1,428.54,211.28Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.29,215.07a20.15,20.15,0,0,1-5.08,4,20.61,20.61,0,0,1-5.89,2.65c-.06-.15,2.6-1.26,5.62-3.09S429.19,215,429.29,215.07Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.66 192.29 449.28 191.59 454.54 201.47 455.52 201.28 456.37 201.99 458.26 211.08 457.45 211.28 447.66 192.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,210.7a104,104,0,0,1-4.64-9.31,101.76,101.76,0,0,1-4.17-9.53,104,104,0,0,1,4.64,9.31C456.3,206.37,458.17,210.64,458,210.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.29,222.7l-24.8,8.8s.15-33.23-1.83-45.39c-2.08-12.77-27.94-13.94-28.38,7.54,0,2.15-1.44,38.71,3.33,52.89s11.82,16.55,22,13.33,38.49-23.36,38.49-23.36Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.29,222.7s.2.28.59.87l1.71,2.62,6.63,10.25.07.1-.1.07c-4.38,3.12-9.88,6.93-16.41,11.18-3.26,2.12-6.78,4.35-10.59,6.58-1.9,1.11-3.88,2.23-5.95,3.28-1,.56-2.11,1-3.19,1.53a30.25,30.25,0,0,1-3.43,1.21,21.17,21.17,0,0,1-7.44.91,12,12,0,0,1-7.12-3.08,20.63,20.63,0,0,1-4.67-6.59,43.73,43.73,0,0,1-2.82-7.84,108,108,0,0,1-2.23-17.15c-.37-5.88-.52-11.91-.54-18,0-5.29.06-10.5.26-15.63a20.25,20.25,0,0,1,1.69-7.47,14.89,14.89,0,0,1,4.69-5.86,16.24,16.24,0,0,1,13.95-2.3,13.19,13.19,0,0,1,6,3.58,11.13,11.13,0,0,1,1.88,2.89,12.36,12.36,0,0,1,.79,3.28c.59,4.37.83,8.62,1,12.7s.32,8,.4,11.72c.17,7.46.2,14.17.18,20l-.21-.15,18.35-6.42,4.84-1.68,1.24-.42.42-.13-.43.17-1.25.46-4.85,1.76-18.22,6.56-.2.07v-.22c0-5.82-.07-12.53-.27-20-.09-3.72-.22-7.63-.43-11.71s-.47-8.31-1.07-12.65a12.25,12.25,0,0,0-.77-3.17,10.49,10.49,0,0,0-1.79-2.75,12.76,12.76,0,0,0-5.76-3.43,15.77,15.77,0,0,0-13.51,2.24,14.35,14.35,0,0,0-4.52,5.66,19.94,19.94,0,0,0-1.65,7.28c-.19,5.11-.26,10.33-.25,15.61,0,6.12.17,12.14.54,18a108.78,108.78,0,0,0,2.19,17.06,44.58,44.58,0,0,0,2.78,7.75,20,20,0,0,0,4.55,6.44,11.62,11.62,0,0,0,6.84,3,20.9,20.9,0,0,0,7.28-.88,31.18,31.18,0,0,0,3.37-1.18c1.08-.51,2.16-1,3.18-1.51,2.06-1,4-2.15,5.94-3.26,3.8-2.21,7.33-4.42,10.6-6.53,6.54-4.21,12.06-8,16.46-11.07l0,.17c-2.82-4.48-5-7.93-6.49-10.28-.73-1.17-1.28-2.06-1.67-2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.38,244.1A8.16,8.16,0,0,1,361,242a35.12,35.12,0,0,1,2.13-4.71A27.92,27.92,0,0,1,366,233a7.26,7.26,0,0,1,1.51-1.53c.12.1-2,2.55-3.94,6.07S360.54,244.16,360.38,244.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,172.38a5.4,5.4,0,0,1,4-2.7,3.05,3.05,0,0,0,1.9-.56,4.39,4.39,0,0,0,.64-1.28,2.73,2.73,0,0,1,3.77-1.1,3,3,0,0,0,.94.54c1.43.34,2.2-2.39,3.63-2.05A3.14,3.14,0,0,0,125,166.7a1.41,1.41,0,0,0,.59,1.63c1.45.73,2.78-2.1,4.32-1.58.82.28,1.24,1.45,2.11,1.44a3,3,0,0,0,.95-.33,2.25,2.25,0,0,1,2.8,1.27c.34.91.16,2.17,1,2.61a2.06,2.06,0,0,0,1.73-.2,5.88,5.88,0,0,1,0,2.64,3.51,3.51,0,0,1,2.34,4.28,7.75,7.75,0,0,1,2.49,1.49,2.63,2.63,0,0,1,.71,2.67,2.42,2.42,0,0,0-.22.62,1.3,1.3,0,0,0,.18.69,12.14,12.14,0,0,1,1.22,2.48,1.78,1.78,0,0,1-1.11,2.21c-.21,0-.46,0-.6.18a.62.62,0,0,0-.11.46,6.19,6.19,0,0,0,.63,1.89,2.66,2.66,0,0,1,.19,1.93,1.13,1.13,0,0,1-1.6.63l1.54,2.78c.31.56.62,1.24.3,1.78-.41.72-1.55.54-2.15,0s-.94-1.37-1.56-1.92a4.86,4.86,0,0,1-.76-.67c-.16-.22-.26-.49-.5-.61-.49-.22-1,.5-.77,1s.7.79,1.13,1.11.85.82.7,1.33c-.07.25-.27.45-.33.7-.23.87,1.08,1.32,1.43,2.14a2.15,2.15,0,0,1-.39,1.87c-.41.7-1.36,1.43-1.89.82-.19-.22-.22-.52-.38-.75a2,2,0,0,0-.8-.55,4.33,4.33,0,0,1-1.73-1.69c.87.64,1.85,1.54,1.63,2.6a4.68,4.68,0,0,1-.61,1.2c-.44.78-.6,1.68-1,2.46a2.09,2.09,0,0,1-2.14,1.24,2,2,0,0,1-2.73,2.76A1.91,1.91,0,0,0,131,211a1.43,1.43,0,0,0-.75.22,4.33,4.33,0,0,1-4.48-.57c.24-.15.47-.31.7-.47a10.08,10.08,0,0,1-4.67-.14,3.46,3.46,0,0,1-2.44-3.58c.13-.66.51-1.42.11-2a1.7,1.7,0,0,0-1.28-.49l-5.87-.49a5.26,5.26,0,0,1-2.72-.74,1.8,1.8,0,0,1-.51-2.49,5,5,0,0,0-2.39-1.53c-1-.31-2.14-.28-3.19-.53a2.94,2.94,0,0,1-2.32-2c-.21-1.06,1-2.24,1.93-1.67-.55-1.53-3.37-.9-4-2.39-.52-1.22.93-2.3,1.51-3.48-.29-.4-.81-.56-1.11-1-.62-.81.09-2,.87-2.62s1.75-1.38,1.72-2.4-1.18-1.93-.88-2.94a1.15,1.15,0,0,1,1.38-.74c.24-2,4-1.53,4.56-3.46a.76.76,0,0,0,0-.47.8.8,0,0,0-.27-.31,8,8,0,0,0-1.8-.75,1.59,1.59,0,0,1-1.11-1.45c.07-.64,1.19-.92,1.35-.28a1.43,1.43,0,0,1,2.26,0,1.55,1.55,0,0,1,1.83-.67,4.68,4.68,0,0,1,1.75,1.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,190.11c-1.29-2.42-3.79-4-6.35-5a7,7,0,0,0-3.36-.63,3,3,0,0,0-2.55,2l.68,1.8c.6,3,3.57,4.82,5.43,7.24.81,1.06,1.6,2.38,2.92,2.55a2.8,2.8,0,0,0,2-.59C126,196,126.36,192.53,125.06,190.11Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.21,203.58a6.13,6.13,0,0,0-2.79-7.35c.66-1.67-.35-3.63-1.85-4.64a12,12,0,0,0-5.13-1.53,8.26,8.26,0,0,0-11-3c-2.95-2.39-7.45-1.54-10.63.53A9.46,9.46,0,0,1,95.44,189a14.92,14.92,0,0,1-2,.32c-3.69.6-6.46,4.16-6.84,7.88a7,7,0,0,1-.29,1.77A9.23,9.23,0,0,1,85,200.86a5.93,5.93,0,0,0-.9,4.85c.36,1.4,1.24,2.73,1,4.15a19.57,19.57,0,0,0-.5,2.11c-.09,2.09,2.6,3.39,2.8,5.47,0,.43,0,.86,0,1.28a3.61,3.61,0,0,0,1,2.38c.45.5,1.07.9,1.3,1.53a5.9,5.9,0,0,1,.15,1.52c.11,1.25,4,5,5.22,5.34l30.39-8.9a5.94,5.94,0,0,0,2.91-6.21,2.14,2.14,0,0,1-.06-1.2,2.49,2.49,0,0,1,.67-.78c1.63-1.64,1.05-4.39.18-6.54a2.75,2.75,0,0,1-.26-.93A3.45,3.45,0,0,1,129.21,203.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54,206.25a16.94,16.94,0,0,0-12.88-11.54,20.85,20.85,0,0,0-8.31.47,12.87,12.87,0,0,0-6.7,3.66c-1.55.9-6,8.36-4.45,14.54,1.69,6.86,4,15.17,6.4,19.94,4.78,9.6,12.93,8.45,12.93,8.45s2,7.7,2,7.7L113.1,282l22.64-40.86-5.49-.69Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,227.23a2.12,2.12,0,0,0-3.54-.57,2.33,2.33,0,0,0-.1,2.58h0c.57.48,1,1,1.77.85l.34-.07a2.36,2.36,0,0,0,1.36-1A2.07,2.07,0,0,0,108.46,227.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.31,221.57a1.35,1.35,0,0,0,1.65.91,1.29,1.29,0,0,0,1-1.58,1.37,1.37,0,0,0-1.66-.92A1.3,1.3,0,0,0,94.31,221.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.74,216.52c.21.12,1-.91,2.36-1.35s2.63-.06,2.73-.27-.21-.36-.76-.54a3.8,3.8,0,0,0-2.25,0A3.53,3.53,0,0,0,92,215.66C91.68,216.12,91.63,216.47,91.74,216.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.35,225a9.14,9.14,0,0,0-2.39.3c-.37.07-.73.11-.87-.12A1.94,1.94,0,0,1,100,224c.06-1,.13-2,.2-3.05.25-4.31.31-7.82.14-7.83s-.52,3.49-.77,7.81c0,1.06-.1,2.07-.15,3a2.17,2.17,0,0,0,.25,1.45.94.94,0,0,0,.75.34,2.22,2.22,0,0,0,.63-.11A9.38,9.38,0,0,0,103.35,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53,241.77A27,27,0,0,0,120,233.9s-1.36,8.25-11.77,10.48Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.51,211.87c.34.27,1.33-.29,2.61-.58s2.42-.29,2.6-.68c.07-.19-.17-.47-.71-.68a4.15,4.15,0,0,0-4.2,1C90.43,211.38,90.35,211.74,90.51,211.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,217.45a1.36,1.36,0,0,1-.9,1.67,1.29,1.29,0,0,1-1.67-.81,1.36,1.36,0,0,1,.89-1.67A1.31,1.31,0,0,1,109.17,217.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,211.08c-.11.21-1.3-.25-2.71.14s-2.25,1.38-2.45,1.24,0-.4.35-.86a3.7,3.7,0,0,1,1.9-1.2,3.51,3.51,0,0,1,2.22.1C110.8,210.71,111,211,111,211.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.06,206.44c-.19.4-1.36.37-2.68.71s-2.35.87-2.7.61c-.15-.13-.07-.5.33-.94a4.33,4.33,0,0,1,2-1.12,4.17,4.17,0,0,1,2.31.06C110.9,206,111.14,206.25,111.06,206.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,216.33c-.23-.75.08-2.79.79-3.14,1.88-.94,5.51-1.9,7.12,3.12,2.21,6.87-5.14,7.68-5.22,7.48S122.73,218.93,121.92,216.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,220.67s.15.05.38.08a1.28,1.28,0,0,0,.9-.27,3.13,3.13,0,0,0,.52-3.1,4.33,4.33,0,0,0-.89-1.61,1.47,1.47,0,0,0-1.19-.63.67.67,0,0,0-.61.56c0,.22.06.34,0,.37s-.18-.07-.22-.37a.78.78,0,0,1,.13-.52,1,1,0,0,1,.61-.39,1.76,1.76,0,0,1,1.59.67,4.23,4.23,0,0,1,1,1.78c.4,1.4.11,2.92-.79,3.53a1.36,1.36,0,0,1-1.15.17C125.77,220.84,125.68,220.69,125.7,220.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,214a4.19,4.19,0,0,0,1-4.38c1,0,1.57-1.49,1.86-2.46s.82-1.58.47-2.53A1.15,1.15,0,0,1,90,204c0-.3.36-.49.61-.67a4.82,4.82,0,0,0,2-4.16,10.29,10.29,0,0,0,5-.7,3.91,3.91,0,0,0,6.22-2.26,3.47,3.47,0,0,0,2.76.95,10.15,10.15,0,0,0,2.9-.74,4.15,4.15,0,0,0,4,3.66,1,1,0,0,1,.76.18,1,1,0,0,1,.13.8,3.25,3.25,0,0,0,3.32,3.3,2.44,2.44,0,0,0,1.35,3.57c.3.07.68.15.74.45a.7.7,0,0,1-.06.35,4.74,4.74,0,0,0-.38,2.61,1.76,1.76,0,0,0,2,1.42,2.3,2.3,0,0,0-.41,1.78c.18.6,1,1,1.47.63.21-.17,3.43-1.92,3.51-2.17,1.12-3.26-2.25-5.41-3.47-8.63a22.43,22.43,0,0,0-5.89-8.37,16.46,16.46,0,0,0-3.49-2.55,21.56,21.56,0,0,0-4.66-1.6A19.68,19.68,0,0,0,102,191c-4,.29-7.43,2.85-10.39,5.54a16.59,16.59,0,0,0-3,3.38,15.33,15.33,0,0,0-1.86,5.1,19.17,19.17,0,0,0-.28,7.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6,212a2.79,2.79,0,0,1,.14-.86c.07-.27.19-.6.28-1a3.32,3.32,0,0,0,0-1.4,9.89,9.89,0,0,0-.56-1.7,7.76,7.76,0,0,1-.58-2.06,6,6,0,0,1,.23-2.45,5.19,5.19,0,0,1,.54-1.24,8.38,8.38,0,0,1,.83-1.15,4.63,4.63,0,0,0,.77-1.23,6.11,6.11,0,0,0,.25-1.5,9.33,9.33,0,0,1,.84-3.19,9.43,9.43,0,0,1,2-2.89,8.77,8.77,0,0,1,1.46-1.14,7.63,7.63,0,0,1,1.75-.77,7.28,7.28,0,0,1,1-.21c.32,0,.64-.08,1-.12a4.71,4.71,0,0,0,1.84-.58c.58-.31,1.11-.72,1.7-1.08a12.3,12.3,0,0,1,1.84-.95,12.85,12.85,0,0,1,2-.65,10.79,10.79,0,0,1,2.13-.26,7.09,7.09,0,0,1,4.19,1.21l.36.26h-.13a8.37,8.37,0,0,1,11.11,3l-.08,0a25.36,25.36,0,0,1,2.81.52,7.71,7.71,0,0,1,2.52,1.15,4.93,4.93,0,0,1,1.64,2.1,3.41,3.41,0,0,1,.07,2.53l0-.11a6,6,0,0,1,2.69,3,6.2,6.2,0,0,1,.35,3.65,5.69,5.69,0,0,1-.25.83c-.1.26-.21.51-.28.76a1.47,1.47,0,0,0,0,.75,4.23,4.23,0,0,0,.24.71,11.89,11.89,0,0,1,.74,2.64,5.51,5.51,0,0,1-.06,2.2,3.45,3.45,0,0,1-.72,1.45c-.28.35-.57.54-.7.72a1.93,1.93,0,0,0-.19.28.92.92,0,0,1,.17-.3c.13-.19.41-.39.68-.73a3.72,3.72,0,0,0,.69-1.44,5.79,5.79,0,0,0,0-2.17,12.1,12.1,0,0,0-.76-2.6,4.18,4.18,0,0,1-.25-.73,1.75,1.75,0,0,1,0-.82,8.11,8.11,0,0,1,.28-.78,5.29,5.29,0,0,0,.24-.8,6.11,6.11,0,0,0-.36-3.55,5.83,5.83,0,0,0-2.63-2.95l-.07,0,0-.07a3.22,3.22,0,0,0-.07-2.4,4.75,4.75,0,0,0-1.58-2,7.53,7.53,0,0,0-2.46-1.11,22.55,22.55,0,0,0-2.79-.51h-.05l0,0a7.81,7.81,0,0,0-4.67-3.57,7.91,7.91,0,0,0-6.14.63l-.06,0-.06,0-.35-.26a6.9,6.9,0,0,0-4-1.16,10.57,10.57,0,0,0-2.1.25,12.21,12.21,0,0,0-2,.63,13.57,13.57,0,0,0-1.82.94c-.58.35-1.12.76-1.71,1.09a5.21,5.21,0,0,1-.94.4,5.47,5.47,0,0,1-1,.19c-.33,0-.65.07-1,.12s-.63.11-.93.2a7.64,7.64,0,0,0-1.7.75,8.17,8.17,0,0,0-1.43,1.11,9.56,9.56,0,0,0-2.84,5.95,5.71,5.71,0,0,1-.26,1.54,4.35,4.35,0,0,1-.8,1.27,10.52,10.52,0,0,0-.83,1.13,6,6,0,0,0-.77,3.61,7.75,7.75,0,0,0,.56,2,10.92,10.92,0,0,1,.55,1.72,3.31,3.31,0,0,1,0,1.44c-.09.4-.22.73-.3,1a3.59,3.59,0,0,0-.15.63A1.17,1.17,0,0,0,84.6,212Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78,186.57s-.21,0-.6-.1a4.8,4.8,0,0,0-1.64,0,4.51,4.51,0,0,0-2.16,1A4.78,4.78,0,0,0,98.9,190a4.58,4.58,0,0,0-.1.89.91.91,0,0,0,.28.71l.24.18H99a3,3,0,0,0-2.06.91,2.93,2.93,0,0,0-.77,1.64,3.14,3.14,0,0,0,.09,1.22c.07.28.14.43.13.43s0,0-.07-.1a1.69,1.69,0,0,1-.13-.31,2.89,2.89,0,0,1-.15-1.25,3,3,0,0,1,.77-1.75,3.16,3.16,0,0,1,2.18-1l-.06.19a1.05,1.05,0,0,1-.36-.87,3.81,3.81,0,0,1,.1-.94,4.81,4.81,0,0,1,1.56-2.61,4.63,4.63,0,0,1,2.27-1,4.71,4.71,0,0,1,1.68,0,4.32,4.32,0,0,1,.44.13C104.74,186.54,104.79,186.57,104.78,186.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.43,191a1.27,1.27,0,0,1-.17.33,4.71,4.71,0,0,1-.61.78,3.46,3.46,0,0,1-1.25.84,2.61,2.61,0,0,1-1.87,0l.15-.08-.12.35a3.49,3.49,0,0,1-.15.34,4.31,4.31,0,0,1-1.38,1.61,4.57,4.57,0,0,1-1.58.72,4,4,0,0,1-1.17.09,1.29,1.29,0,0,1-.41-.08,6.17,6.17,0,0,0,1.54-.16,4.59,4.59,0,0,0,1.5-.73,4.42,4.42,0,0,0,1.31-1.54c0-.11.1-.22.14-.33s.07-.22.11-.32l0-.12.11.05a2.42,2.42,0,0,0,1.72,0,3.49,3.49,0,0,0,1.21-.76C118.14,191.43,118.39,191,118.43,191Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.06,196.26s0,.05,0,.13a1.19,1.19,0,0,1,0,.38,2,2,0,0,1-.88,1.09,3.7,3.7,0,0,1-2,.4c-.39,0-.8,0-1.23-.09a2,2,0,0,1-1.22-.57l-.08-.1h.18a8.13,8.13,0,0,1-1.66,1.86,3.74,3.74,0,0,1-1.87.8,2.64,2.64,0,0,1-1.36-.17,1.57,1.57,0,0,1-.33-.18c-.07,0-.11-.07-.1-.08s.16.08.46.18a2.6,2.6,0,0,0,1.31.1,3.64,3.64,0,0,0,1.77-.81,8.28,8.28,0,0,0,1.6-1.83l.09-.12.09.12.07.08a1.82,1.82,0,0,0,1.09.51c.4.06.81.08,1.19.1a3.66,3.66,0,0,0,1.95-.33,1.92,1.92,0,0,0,.88-1C124.06,196.45,124,196.26,124.06,196.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,169.36s-.11,0-.31.16a1.72,1.72,0,0,0-.61.73,2.26,2.26,0,0,0-.11,1.48,6.72,6.72,0,0,0,.84,1.8l.07.1-.12,0a4.06,4.06,0,0,0-2.16,1.47,3.21,3.21,0,0,0-.55,2.82,2.94,2.94,0,0,0,1.72,2l.29.11-.3.09a3.69,3.69,0,0,0-2.25,2,3.58,3.58,0,0,0-.23,2.39,4,4,0,0,0,.71,1.45c.24.3.4.43.38.45l-.12-.09a3.15,3.15,0,0,1-.32-.32,3.75,3.75,0,0,1-.77-1.46,3.68,3.68,0,0,1,.18-2.5,3.9,3.9,0,0,1,2.36-2.08v.2a3.18,3.18,0,0,1-1.85-2.13,3.26,3.26,0,0,1,0-1.61,3.56,3.56,0,0,1,.65-1.39,4.26,4.26,0,0,1,2.27-1.52l0,.13a6.06,6.06,0,0,1-.83-1.86,2.3,2.3,0,0,1,.16-1.55,1.6,1.6,0,0,1,.68-.74l.24-.1C123.74,169.36,123.77,169.35,123.77,169.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,180.46s0,0-.09.1-.16.16-.29.26a5.09,5.09,0,0,1-1.29.75,5.9,5.9,0,0,1-2.25.42,5.54,5.54,0,0,1-2.8-.8l.15-.06a4.57,4.57,0,0,1-2.43,3.09,3.47,3.47,0,0,1-4-.76l.17-.06a2.88,2.88,0,0,1-.46,1.43,3.85,3.85,0,0,1-.93,1,5.31,5.31,0,0,1-2,.88,11.18,11.18,0,0,1-1.42.2,4,4,0,0,1-.52,0,2.49,2.49,0,0,1,.51-.09c.33-.05.81-.11,1.4-.25a5.49,5.49,0,0,0,2-.89,3.13,3.13,0,0,0,1.3-2.29v-.26l.17.19a3.3,3.3,0,0,0,3.76.69,4.42,4.42,0,0,0,2.33-2.94l0-.14.12.08a5.32,5.32,0,0,0,2.69.79,5.54,5.54,0,0,0,2.2-.36A6.67,6.67,0,0,0,140.72,180.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5,192.6a.25.25,0,0,1,0,.15.79.79,0,0,1-.34.3,3.4,3.4,0,0,1-1.6.22,3.92,3.92,0,0,1-3.57-3.5v0l.18.06a4.7,4.7,0,0,1-2.64,1.25,5.26,5.26,0,0,1-2.38-.26,5.68,5.68,0,0,1-1.43-.72,3,3,0,0,1-.46-.37,9.35,9.35,0,0,0,1.94.95,5.43,5.43,0,0,0,2.3.2,4.65,4.65,0,0,0,2.52-1.2l.15-.15,0,.21v0a3.82,3.82,0,0,0,1.27,2.45,3.9,3.9,0,0,0,2.1.92,3.51,3.51,0,0,0,1.55-.15A.75.75,0,0,0,137.5,192.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,174.3a6.42,6.42,0,0,0,.35,2.22,5.08,5.08,0,0,0,1.35,2,5,5,0,0,0,4.37,1.1l.13,0v.13a6.32,6.32,0,0,0,.44,2.3,6.48,6.48,0,0,0,.94,1.63,5.29,5.29,0,0,0,.47.53.54.54,0,0,0,.46.16.33.33,0,0,0,.25-.17c0-.06,0-.1,0-.1a.16.16,0,0,1,0,.12.38.38,0,0,1-.27.23.61.61,0,0,1-.53-.16,4.21,4.21,0,0,1-.51-.52,6.26,6.26,0,0,1-1.49-4l.13.1a5.25,5.25,0,0,1-1.78.1,5.18,5.18,0,0,1-2.77-1.25,5,5,0,0,1-1.64-3.74,3.52,3.52,0,0,1,0-.45C108.77,174.35,108.78,174.3,108.79,174.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,225.3c-.21,0-.07,1.39-1.15,2.5s-2.57,1.1-2.56,1.29.35.24,1,.19a3.46,3.46,0,0,0,2.14-1,3,3,0,0,0,.88-2.09C108.13,225.61,107.94,225.28,107.85,225.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,296.78c-.61-4.62-4.47-37.45-4.47-37.45s-.28-8.76-7.62-14-21-5.77-21.65-5.25c-1.42,1.15-10.23,29.73-13.08,29.73s-8.16-20.7-8.16-20.7l-1.23-4.77-9.66,3.89s-4.8,3.15-7.38,11.63c-1.59,5.2-7.5,37.73-7.5,37.73l-14.78-1.05v12.84l29.66,7a16.81,16.81,0,0,0,5.28-7.39c.45-1.22.35-5.59,0-11.45a12.12,12.12,0,0,0,1.34,1.24l6.56,18.77c28.94,7,59.52,15.75,73,6.67C182.69,312.23,164.82,299.88,164.4,296.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.64,264.31a6.29,6.29,0,0,1,.71,1.45c.41.94,1,2.29,1.61,3.91l0,.09-.06.1a23.28,23.28,0,0,0-2.64,11.87c.07,1.93.32,3.1.23,3.12a2.54,2.54,0,0,1-.25-.81,18.05,18.05,0,0,1-.35-2.28,21.21,21.21,0,0,1,2.61-12.12l0,.19c-.6-1.63-1.09-3-1.42-4A7.23,7.23,0,0,1,98.64,264.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.94,256.56l-5.09-2A101.91,101.91,0,0,0,44,262.25a24.5,24.5,0,0,0-5.77,7.24c-.7-1.79-1.28-3-3.41-4a11.48,11.48,0,0,0-9.22.22l-1.77,3.69,9.71,7.29,12,5.65,9-.62,17.08-7.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,296,22,269.65s9.11-1.47,11.61,0,1.47,4.56,1.47,4.56l3.3-.31s2-5.28,9.19-10.12a114.68,114.68,0,0,1,13.81-7.94l30.85,28.21,1.48,7s-18.08,4.14-24.11,10.31Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.66,299.67c-.09.11-7.6-5.56-16.79-12.68S38.31,274,38.4,273.9s7.61,5.56,16.79,12.68S71.75,299.56,71.66,299.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,300.49c-.09.12-7.6-5.56-16.79-12.68s-16.56-13-16.47-13.09,7.61,5.56,16.79,12.68S68,300.38,67.93,300.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,379.11,98.87,399.8s-16.1,17.93-14.37,21.95l38.73-19.5L106.9,369.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,392a1.89,1.89,0,0,1,2.05,1.35,1.72,1.72,0,0,1-1.2,2.06,2,2,0,0,1-2.16-1.44c-.14-.91.6-2,1.48-2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,402.25,121.46,399,85,418.9s-1.32,1.66-.49,2.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,399.91c.11.19,1.1-.19,2.35,0s2.17.77,2.3.6-.72-1.18-2.24-1.36S98,399.75,98.14,399.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,403.73c0,.21,1,.14,2.11.66s1.7,1.32,1.88,1.22-.26-1.3-1.6-1.92S94.88,403.53,95,403.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.23,410c.2,0,0-1.17-1.07-2s-2.14-.84-2.14-.64.85.52,1.69,1.23S95,410.09,95.23,410Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.06,394.92c.17.14.9-.57,2-1s2.12-.53,2.13-.75-1.14-.53-2.44,0S95.89,394.81,96.06,394.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.75,375.38l4.38,27.74-2.86,22.95a2.88,2.88,0,0,0,2.7,3.23h0a2.85,2.85,0,0,0,2.4-1.07c3.7-4.65,17.23-21.81,16.79-23.82-.5-2.33-2.68-29.58-2.68-29.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,429.3l18.94-26.77.16,1.18a4.35,4.35,0,0,1-.64,2.92c-1.49,2.31-5.74,8.62-16,21.59A2.89,2.89,0,0,1,124,429.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,394.32a1.72,1.72,0,0,0-.17,2.31,1.66,1.66,0,0,0,2.29.19,1.82,1.82,0,0,0,.17-2.45,1.73,1.73,0,0,0-2.41.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.69,416.28c-.15.1-1-1.28-2.73-1.84a8.93,8.93,0,0,0-3.29-.18c0-.06.29-.33.93-.51a4.63,4.63,0,0,1,4.66,1.56C128.66,415.84,128.76,416.25,128.69,416.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.21,420.27a25.07,25.07,0,0,0-2.63-.86,21.51,21.51,0,0,0-2.76,0c-.1-.14,1.16-.91,2.86-.63S127.34,420.18,127.21,420.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,411c-.11.15-1.67-1.06-4-1.6s-4.22-.23-4.25-.41,2-.81,4.4-.19A6.45,6.45,0,0,1,131.74,411Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.11,402.46c-.05.17-1.68-.26-3.69-.06s-3.53.89-3.61.72,1.39-1.15,3.56-1.34S131.18,402.32,131.11,402.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,394.28c-.06.17-1.74-.55-3.84-.17a13.84,13.84,0,0,0-3.56,1.43c-.06-.05.2-.44.79-.9a6.13,6.13,0,0,1,2.67-1.13,6.28,6.28,0,0,1,2.89.18C129.69,393.93,130.06,394.21,130,394.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12,319.32s-29-13.3-35.92-10.91-16,12.51-9.31,26.34S90.32,390,90.32,390l21.12-12.68L95.74,345.4l18.1,5.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,310.67s-.51,0-1.33,0c-3.74.15-15.14,2.61-15.14,15.25,0,15.43,15.29,61.15,15.29,61.15l24.91-2.15L137.74,347s13.19,10.27,16.11,10.54,21.46.77,23.16-.27c19-11.72,7.56-37.1,7.56-37.1-8.26,3.25-16.94,5.34-26.08.76C158.49,320.91,135.12,312,119.16,310.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.29,335.06s0,.06.05.19.06.35.1.59c.08.51.2,1.28.31,2.29A54.92,54.92,0,0,1,138,347v0c1.18,8.76,3,22.14,5.12,38l0,.26-.26,0-23.37,2-1.54.13-.2,0-.07-.2c-3-9.54-5.75-18.65-8.22-26.93s-4.67-15.73-6.25-22.07a41,41,0,0,1-1.12-8.73,23.43,23.43,0,0,1,.8-6.6,17.25,17.25,0,0,1,1.58-3.88c.24-.42.45-.72.58-.93a2.65,2.65,0,0,1,.22-.3,2.38,2.38,0,0,1-.17.33c-.12.22-.32.52-.54.95a18.64,18.64,0,0,0-1.48,3.88,23.8,23.8,0,0,0-.7,6.54,41.43,41.43,0,0,0,1.19,8.66c1.61,6.3,3.88,13.74,6.35,22s5.23,17.38,8.26,26.9l-.27-.18,1.53-.13,23.38-2-.23.28c-2-15.84-3.78-29.22-4.91-38h0v0a59,59,0,0,0-.13-8.78c-.09-1-.18-1.78-.24-2.3l-.06-.59C137.28,335.13,137.28,335.06,137.29,335.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.64,284.71l29.71,8.88s8.05-37.95,12.19-44.15,14.12-5.63,17.73,3.93-9.7,56.44-17,61.61-22.14-1.32-25-2.61-23.14-13.11-23.14-13.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.64,284.71s-.11.34-.34,1l-1,2.82c-.92,2.48-2.28,6.11-4,10.79l-.06-.15L108.73,308l4.73,2.64c.81.44,1.64.9,2.49,1.31s1.76.79,2.66,1.16a51.08,51.08,0,0,0,11.89,3.33,21.42,21.42,0,0,0,6.54-.06,8.86,8.86,0,0,0,1.61-.42,7.77,7.77,0,0,0,1.54-.66,6.62,6.62,0,0,0,1.39-.93,3.73,3.73,0,0,0,.58-.61,5.83,5.83,0,0,0,.55-.66,35.26,35.26,0,0,0,3.46-6.18c1-2.19,1.93-4.46,2.8-6.79,1.74-4.66,3.29-9.54,4.69-14.57s2.66-10.23,3.63-15.57a68.51,68.51,0,0,0,1.32-12.41,16.68,16.68,0,0,0-.27-3,5.83,5.83,0,0,0-.18-.72,3.66,3.66,0,0,0-.25-.7l-.61-1.37a12.37,12.37,0,0,0-3.79-4.44,9.37,9.37,0,0,0-5.4-1.75,9,9,0,0,0-5.25,1.73,8.8,8.8,0,0,0-1.93,2,7.29,7.29,0,0,0-.69,1.18,7.54,7.54,0,0,0-.59,1.25c-.36.85-.71,1.7-1,2.57s-.61,1.72-.87,2.58c-2.19,6.9-3.83,13.56-5.35,19.72s-2.79,11.87-3.91,17l0,.19-.18-.06-21.73-6.59-5.87-1.81-1.53-.47-.53-.18.51.13,1.51.43,5.86,1.71,21.88,6.44-.22.14c1.09-5.15,2.36-10.86,3.84-17s3.12-12.83,5.31-19.76c.26-.87.56-1.73.87-2.6s.64-1.74,1-2.61a8.77,8.77,0,0,1,.61-1.28,7.07,7.07,0,0,1,.73-1.24,9.06,9.06,0,0,1,2-2.07,9.29,9.29,0,0,1,5.55-1.84A9.83,9.83,0,0,1,153.8,247a12.92,12.92,0,0,1,4,4.62l.63,1.42a3.6,3.6,0,0,1,.26.74,7.1,7.1,0,0,1,.2.76,17.13,17.13,0,0,1,.28,3.11,68.36,68.36,0,0,1-1.33,12.52c-1,5.35-2.24,10.56-3.64,15.6s-3,9.94-4.72,14.61c-.88,2.34-1.81,4.62-2.82,6.83a36.83,36.83,0,0,1-3.53,6.26,6.33,6.33,0,0,1-.57.69,3.82,3.82,0,0,1-.63.64,6.6,6.6,0,0,1-1.48,1,7.37,7.37,0,0,1-1.61.69,9.89,9.89,0,0,1-1.68.44,21.7,21.7,0,0,1-6.68,0,50.84,50.84,0,0,1-12-3.39c-.92-.38-1.81-.75-2.68-1.18s-1.69-.89-2.51-1.33l-4.72-2.66c-6.07-3.46-11.28-6.51-15.5-9l-.09-.06,0-.1,4.18-10.81c.47-1.2.83-2.13,1.09-2.77S98.64,284.71,98.64,284.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.64,284.71,96.15,284s-.51-10.75-3.43-11.29c-2.06-.38-12.76,1.89-13.11,5.07s2.82,2.79,2.82,2.79-3.67,1-3.66,3.23c0,1.14,1.7,1.36,3.28,1.36,0,0-2.36,1.27-.91,3s4.31.77,4.31.77l4-.83a21.31,21.31,0,0,0,.29,6.33c.7,2.38,4,3.23,4,3.23l4.91-12.92Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,277.36c0,.05-.65.05-1.68.25a40.27,40.27,0,0,0-4,1c-1.51.49-2.86,1.08-3.85,1.46a5.33,5.33,0,0,1-1.64.51,5.84,5.84,0,0,1,1.5-.85,27.5,27.5,0,0,1,3.84-1.61,21.88,21.88,0,0,1,4.09-.83C92.33,277.13,93,277.27,93,277.36Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.27,283.16c0,.16-2.51.11-5.48.81s-5.21,1.83-5.28,1.68a12.9,12.9,0,0,1,5.16-2.18A12.94,12.94,0,0,1,92.27,283.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08,295.06s-2.77,1.32-1.19,4.49l.35,1.05a4.19,4.19,0,0,0,.84,5,3.6,3.6,0,0,0,2.64,4.45s-.53.64.75,1.44a5,5,0,0,0,4.19.44c2-.67,5.17-1.84,5.35-2.9.26-1.58-1.59-2.24-2.51-1.85s3.56-1.71,3.56-3.43a4.11,4.11,0,0,0-.66-2.51s1.85.14,1.32-2.24-3.3-2.51-3.3-2.51,1.32-1.58-1.58-2.64S59.08,295.06,59.08,295.06Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.74,296.23c0,.16-2.9.67-6.35,1.86s-6.09,2.55-6.16,2.41a6.09,6.09,0,0,1,1.65-1.05,30.76,30.76,0,0,1,4.34-1.85,31.18,31.18,0,0,1,4.57-1.19A6.75,6.75,0,0,1,70.74,296.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.74,301.38a50.84,50.84,0,0,1-6.87,2.4,50.18,50.18,0,0,1-7,1.9,52.54,52.54,0,0,1,6.87-2.4A53.74,53.74,0,0,1,72.74,301.38Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,307.25a16.84,16.84,0,0,1-3.91,1.69,17.34,17.34,0,0,1-4.09,1.2,17.89,17.89,0,0,1,3.91-1.69A18.41,18.41,0,0,1,69.5,307.25Z",
    style: {
      fill: "#ff9a6c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.56,447.22v1s17.79,7.1,17.95,10.38l-35.47-.5.66-11.41A20.9,20.9,0,0,0,235.56,447.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,458.12l.16-2.75,33.93,1.49s1.57.69,1.38,1.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68,448.34c0,.16-.88.23-1.74.75s-1.32,1.23-1.48,1.16.11-1,1.17-1.65S235.72,448.18,235.68,448.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,449.88c0,.16-.72.43-1.32,1.13s-.78,1.45-.95,1.44-.27-1,.49-1.81S239.37,449.72,239.38,449.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.42,454.21c-.16,0-.38-.8.08-1.71s1.27-1.27,1.34-1.13-.44.63-.8,1.38S241.6,454.2,241.42,454.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.46 427.92 220.65 454.39 207.5 446.55 210.75 426.61 223.46 427.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,445.5s8.8,8.62,13.61,3.87l.88,2.6,3.3,18.23a2.38,2.38,0,0,1-1.71,2.72,2.55,2.55,0,0,1-2.54-.71c-3.33-3.61-15.52-17-15.23-18.6l.48-4.35a32.72,32.72,0,0,1,1-3.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.29,473l-17.18-20.9-.09.95a2.6,2.6,0,0,0,.7,2.19c1.35,2.1,5.19,6.88,14.41,17a2.58,2.58,0,0,0,2.16.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,462.69a7.34,7.34,0,0,1,2.26-1.57,8,8,0,0,1,2.8-.25c0-.05-.26-.25-.81-.38a4.14,4.14,0,0,0-2.18.17,3.69,3.69,0,0,0-1.73,1.24C218.78,462.34,218.71,462.66,218.76,462.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,465.85a20.84,20.84,0,0,1,2.21-.78,22.93,22.93,0,0,1,2.36-.08,2.94,2.94,0,0,0-2.47-.41C220.84,464.85,220.06,465.78,220.18,465.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,458.55a24.44,24.44,0,0,1,3.32-1.42,26.54,26.54,0,0,1,3.62-.47,5.87,5.87,0,0,0-3.77,0A5.37,5.37,0,0,0,216,458.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.71,446.39a15.17,15.17,0,0,0-.18,2.82h0v0c.19,1.22.46,2.77.76,4.45.36,2,.71,3.8,1,5.09a10.71,10.71,0,0,0,.54,2.09,10.21,10.21,0,0,0-.23-2.14c-.19-1.31-.5-3.12-.86-5.11-.3-1.69-.6-3.23-.85-4.44v0A15.84,15.84,0,0,0,221.71,446.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93,278.06s6.86,23.16-4.77,52.77S251,384.12,250.59,390.49s-1.15,13-7.26,33.17c-4.47,14.74-7.77,23.56-7.77,23.56-4.63,2.53-9.55,3.22-14,.76,0,0,.43-35.17,7.14-58.85s11.31-60.7,9-74.08,2.68-21,2.68-21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.22,311.51c-4.46-20.84,9.28-42.13,9.28-42.13l35.76,28.17s7.57,84.29,3.09,95.22-25.93,55.54-25.93,55.54L206,444.45s6.1-36.35,11-45.57c3.51-6.64,9.27-9.8,6.58-18.45S203.88,328.55,200.22,311.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,278.51c.13,0-28.52,20.32-28.52,20.32l-38.41-25.3,4-14.51s22.71,9.48,32.9,7.44,21.36-10.86,21.36-10.86A185.08,185.08,0,0,1,274.1,278.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3,283.42l-.18.23-.52.7-2,2.74-7.47,10.38,0,0v.05c.36,3.88.5,8.39.75,13.42s.52,10.55.81,16.49.67,12.29,1,18.94.76,13.61,1.45,20.76c.71,6,1.35,11.8.82,17.42a40,40,0,0,1-.58,4.14,28.15,28.15,0,0,1-1,4c-1,2.53-2.11,5-3.18,7.35-4.34,9.5-8.41,18-11.8,25.14l-8.06,16.9c-.94,2-1.68,3.53-2.19,4.6-.23.52-.42.92-.55,1.2a4,4,0,0,0-.18.42s.08-.13.22-.4l.6-1.18c.52-1.06,1.28-2.6,2.26-4.57l8.19-16.84c3.43-7.13,7.53-15.61,11.89-25.11,1.08-2.38,2.21-4.8,3.21-7.38a26.94,26.94,0,0,0,1-4,41.23,41.23,0,0,0,.6-4.18c.53-5.67-.11-11.56-.82-17.5-.69-7.13-1-14.09-1.46-20.74s-.73-13-1.06-18.94-.61-11.46-.87-16.49-.44-9.54-.83-13.42l0,.08,7.35-10.45,1.94-2.78.49-.72C255.26,283.51,255.31,283.43,255.3,283.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.28,252.66a19.47,19.47,0,0,1,3.47,5.26,9.6,9.6,0,0,1-2-2.49A9.82,9.82,0,0,1,264.28,252.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,127.73a16.68,16.68,0,0,1,6.2,14.15c-.2,2.6-.91,5.56.78,7.54s5,1.91,6.55,3.93c1.89,2.37.31,5.91,1,8.87a6,6,0,0,0,6.38,4.46,23.37,23.37,0,0,1-11.62,5l-3.25-4.18c1.23,1.46.9,3.79-.29,5.29a9.84,9.84,0,0,1-4.86,2.88,29.74,29.74,0,0,1-26.07-4.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,150.67c.65-2,1.74-3.83,2.18-5.88.94-4.4-1.21-9.35.93-13.32,1.52-2.82,4.76-4.2,7.82-5.14s6.35-1.74,8.63-4c1.67-1.65,2.63-3.92,4.3-5.57,2.37-2.36,5.89-3.16,9.23-3.36A20.07,20.07,0,0,1,250.14,115a11,11,0,0,1,6.2,7.75c.27,1.66.07,3.39.59,5,.57,1.75,1.95,3.11,2.8,4.75a8.82,8.82,0,0,1-2.21,10.57L234,173.53c-5,1.87-16.94-.39-20.77-4.05S205.35,155.7,207,150.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9,139.23c-1-6.91-6.23-15.07-13.09-13.81l-21.18,7.12c-2.09.38-.59,3.78-.39,5.89l4.61,47.78s-2.86,2-3.89,1.65a.29.29,0,0,0-.34.43c2.55,3.69,14.55,19.84,26.93,14.91,2.77-1.1-.29-9.81,0-13l-.37-8.25c-.28-4.21-.41-5.93-.4-5.89s8.75-2.16,9.7-13.87C259,156.32,258,146.91,256.9,139.23Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,150.4a1.49,1.49,0,0,1-1.31,1.61,1.42,1.42,0,0,1-1.63-1.22,1.49,1.49,0,0,1,1.31-1.61A1.42,1.42,0,0,1,254.25,150.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,151.29a1.48,1.48,0,0,1-1.32,1.61,1.42,1.42,0,0,1-1.63-1.22,1.49,1.49,0,0,1,1.32-1.61A1.43,1.43,0,0,1,240,151.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,145c-.16.27-1.54-.6-3.27-.35s-2.84,1.44-3.07,1.22,0-.56.51-1.11a3.91,3.91,0,0,1,5.05-.69C255.79,144.43,256,144.85,256,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43,146.25c-.2.25-1.56-.73-3.42-.65s-3.18,1.13-3.39.89.09-.55.67-1a4.46,4.46,0,0,1,2.7-1,4.33,4.33,0,0,1,2.73.83C240.32,145.71,240.53,146.14,240.43,146.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.26,157.2a10.74,10.74,0,0,1,2.56-.67c.4-.07.78-.18.83-.46a2.12,2.12,0,0,0-.36-1.19l-1.45-3c-2-4.3-3.51-7.84-3.33-7.92s2,3.34,4,7.63c.49,1.06.95,2.07,1.4,3a2.4,2.4,0,0,1,.33,1.59,1.05,1.05,0,0,1-.62.65,3,3,0,0,1-.69.15A10.33,10.33,0,0,1,246.26,157.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.82,176a29.51,29.51,0,0,1-15.82-3s4.52,7.83,16,5.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.39,161.86a2.5,2.5,0,0,1,.82-1,2,2,0,0,1,1.38-.14,3.22,3.22,0,0,1,1.81.92,1.94,1.94,0,0,1,.46,1.91h0c-.18.67-1.18,1-1.86,1.16a3,3,0,0,1-2-.42,1.77,1.77,0,0,1-1-1.32A2.13,2.13,0,0,1,241.39,161.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.72,159.62c.25,0,.39,1.69,2,2.81s3.41.78,3.44,1c0,.1-.38.36-1.16.44a4.32,4.32,0,0,1-2.87-.75,3.77,3.77,0,0,1-1.54-2.37C241.44,160.06,241.6,159.61,241.72,159.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,140c-.12.45-1.73.37-3.59.74s-3.33,1-3.61.62c-.13-.18.11-.6.68-1.07a6.07,6.07,0,0,1,2.63-1.15,6.15,6.15,0,0,1,2.86.11C240,139.48,240.34,139.79,240.29,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,139.13c-.29.38-1.58.11-3.09.2s-2.77.46-3.1.1c-.14-.17,0-.55.57-.93a4.64,4.64,0,0,1,2.46-.79,4.7,4.7,0,0,1,2.52.54C254.9,138.58,255.1,138.94,255,139.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.94,134.2c1.07-1.64,3-2.49,4.82-3.19a106.69,106.69,0,0,1,24.54-6.25c1,1.72.08,4.06-1.5,5.32s-3.6,1.75-5.49,2.45-3.82,1.79-4.59,3.65-.13,4.32-.86,6.33c-1.25,3.47-6.09,4.59-7.32,8.06-.93,2.63.6,5.43,1,8.19a10,10,0,0,1-9.78,11.34q-.87-14.92-1.73-29.85C216.89,138.18,216.81,136,217.94,134.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,159.34c1.57-1.41,3.54-2.63,4.17-4.64.91-2.94-1.44-6.39.07-9.06,1.39-2.44,5.47-2.31,6.75-4.8,1-2-.15-3.67.23-5.38s2.81-3.2,4.55-3l13.59,19.69c1.26,6.61,2.53,10.12,1.11,14a31.51,31.51,0,0,0-2.1,6.42c-.3,2.24.27,4.77,2.1,6.1-8.13.63-15.74-3.62-22.77-7.73l-7.45-4.35a5.58,5.58,0,0,1-2.05-1.7C195,163.07,196.33,160.75,197.9,159.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,168.94a3.81,3.81,0,0,0,.87.17,7.7,7.7,0,0,0,2.53-.18,7.85,7.85,0,0,0,3.53-1.9,7.7,7.7,0,0,0,2.32-4.75,8,8,0,0,0-.26-3.12,12.93,12.93,0,0,0-1.51-3,11.9,11.9,0,0,1-1.56-3.13,4,4,0,0,1,.44-3.44c.74-1,2.11-1.24,3.38-1.75a3.25,3.25,0,0,0,2.29-3.41,22.56,22.56,0,0,0-.92-4.23,4.57,4.57,0,0,1,0-2.08,2.94,2.94,0,0,1,1.17-1.65,8.12,8.12,0,0,1,4.11-1.09,8.81,8.81,0,0,0,4.19-1.24,7.89,7.89,0,0,0,2.86-3.1,13.05,13.05,0,0,0,1.06-3.89,18.11,18.11,0,0,1,.79-3.66,8.18,8.18,0,0,1,1.92-2.88,9.12,9.12,0,0,1,10.65-1.49,11.19,11.19,0,0,1,3.13,2.38,14.69,14.69,0,0,1,1.93,2.77.79.79,0,0,0-.08-.21c-.06-.13-.14-.34-.28-.59a10,10,0,0,0-1.44-2.09,11,11,0,0,0-3.14-2.5,9.51,9.51,0,0,0-5.18-1.14,9.66,9.66,0,0,0-5.87,2.59,8.49,8.49,0,0,0-2,3,17.73,17.73,0,0,0-.84,3.73,12.9,12.9,0,0,1-1,3.75,7.44,7.44,0,0,1-2.71,2.92,8.4,8.4,0,0,1-4,1.16,8.59,8.59,0,0,0-4.34,1.18A3.41,3.41,0,0,0,216,138a5.06,5.06,0,0,0,0,2.29,22.88,22.88,0,0,1,.92,4.15,3.27,3.27,0,0,1-.47,1.86A3.21,3.21,0,0,1,215,147.4c-.61.26-1.26.44-1.89.7a4,4,0,0,0-1.67,1.2,4.45,4.45,0,0,0-.49,3.82,12.09,12.09,0,0,0,1.63,3.23,12.8,12.8,0,0,1,1.49,2.92,7.61,7.61,0,0,1,.28,3,7.5,7.5,0,0,1-2.17,4.6,7.78,7.78,0,0,1-3.39,1.91A8.93,8.93,0,0,1,205.39,168.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.56,154.94a1.61,1.61,0,0,0-.27.66,2.92,2.92,0,0,0,.35,2,3.07,3.07,0,0,0,1,1.09,3.24,3.24,0,0,0,1.73.46,4,4,0,0,0,3.56-2.26,5.32,5.32,0,0,0,.58-2.47,7.55,7.55,0,0,0-.57-2.69c-.65-1.75-1.82-3.47-1.84-5.52a3.75,3.75,0,0,1,.94-2.79,4.07,4.07,0,0,1,2.95-.93,9.77,9.77,0,0,0,3.52-.36,3.08,3.08,0,0,0,1.45-1.22,4.26,4.26,0,0,0,.59-1.79,14.65,14.65,0,0,0-.29-3.61,7.85,7.85,0,0,1,.19-3.35,8.38,8.38,0,0,1,3.78-5,12,12,0,0,1,5.63-1.29,16.58,16.58,0,0,0,5.14-.81,11,11,0,0,0,5.64-4.85,7.57,7.57,0,0,0,1-2.58,14.27,14.27,0,0,1-1.12,2.49,11,11,0,0,1-2,2.46,10.64,10.64,0,0,1-3.57,2.17,16.72,16.72,0,0,1-5.05.73,12.34,12.34,0,0,0-5.83,1.3,8.88,8.88,0,0,0-4,5.22,8.39,8.39,0,0,0-.21,3.53,14.28,14.28,0,0,1,.29,3.49,3,3,0,0,1-1.75,2.63,9.54,9.54,0,0,1-3.35.34,4.54,4.54,0,0,0-3.26,1.07,4.19,4.19,0,0,0-1.06,3.12,8,8,0,0,0,.75,3c.39.92.83,1.77,1.16,2.63a7.17,7.17,0,0,1,.57,2.54,5.07,5.07,0,0,1-.51,2.32,3.77,3.77,0,0,1-3.26,2.15,3,3,0,0,1-1.62-.39,2.92,2.92,0,0,1-1-1,3,3,0,0,1-.42-1.91A5,5,0,0,1,194.56,154.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17,159.79a3.18,3.18,0,0,1,0,2.13,2.79,2.79,0,0,1-1.68,1.71,3,3,0,0,1-3-.81,2.72,2.72,0,0,1-.69-1.71,5.31,5.31,0,0,1,.31-2.05c.43-1.38,1.31-2.87,1.17-4.67a6.51,6.51,0,0,0-2.47-4.69,7.68,7.68,0,0,0-2.53-1.34,11.33,11.33,0,0,0-2.89-.41,15.82,15.82,0,0,1-2.81-.29,3.84,3.84,0,0,1-2.19-1.36,4.61,4.61,0,0,1-.79-2.41,9.07,9.07,0,0,1,.21-2.5,18.72,18.72,0,0,0,.73-4.76,7.2,7.2,0,0,0-1.45-3.94,9.25,9.25,0,0,0-2.65-2.24,18.74,18.74,0,0,1-2.11-1.46,5.25,5.25,0,0,1-1.33-1.71s0,0,0,.14a3.61,3.61,0,0,0,.16.4,4.46,4.46,0,0,0,1,1.31,16.66,16.66,0,0,0,2.1,1.54,9.2,9.2,0,0,1,2.52,2.22,6.92,6.92,0,0,1,1.33,3.76,19.32,19.32,0,0,1-.76,4.65,9.45,9.45,0,0,0-.24,2.62,5,5,0,0,0,.87,2.65,4.16,4.16,0,0,0,2.45,1.54,14.86,14.86,0,0,0,2.89.31,10.91,10.91,0,0,1,2.78.39,7.23,7.23,0,0,1,2.38,1.25,6.13,6.13,0,0,1,2.33,4.36c.14,1.64-.67,3.07-1.12,4.52a6,6,0,0,0-.3,2.2,3,3,0,0,0,.82,1.9,3.21,3.21,0,0,0,3.31.84,3,3,0,0,0,1.78-1.9,3,3,0,0,0,.08-1.66A2,2,0,0,0,280.17,159.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.63,242.53c.13.7,2.54,11.34,5.31,17s2.28,5.95,6.71,6.46,11,1.28,14.53-2.64,4.21-12,3.09-16.43-6.79-12-6.79-12l-12-31.4-6.18,2-4.69,26.82Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.46,203.54a23.72,23.72,0,0,0-5.57-9.66c-1.92-2-19.37-8.06-19.37-8.06-15.26,3.5-22.63-3.43-24.21-3.66-1.09-.16-13.23,1.42-13.23,1.42L208.69,220s1.4,25,1.51,25.18-4.63,17.09-4.63,17.09,29.51,11.83,41.17,14.49,23.84-12.28,23.84-12.28l-3.2-25.39Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.28,208c.15,0-.34,12-1.08,26.87s-1.46,26.86-1.6,26.85.34-12,1.08-26.87S271.14,208,271.28,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.86,214.6s.57.14,1.24.77a2.31,2.31,0,0,1,.47.64,1.12,1.12,0,0,1,.11.47,1,1,0,0,1-.11.5,2,2,0,0,1-1.58,1.29,2,2,0,0,1-1.08-.1c-.32-.11-.6-.23-.87-.35-.54-.25-1-.5-1.39-.71-.77-.44-1.22-.76-1.18-.82s.54.14,1.34.49l1.42.59a3.26,3.26,0,0,0,1.67.39,1.54,1.54,0,0,0,1.23-1c.25-.41-.05-.84-.3-1.17C267.28,215,266.82,214.67,266.86,214.6Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.08,183.58s-15.63.36-17.19,17.75,1.66,48,3.93,52.28,28,12.53,28,12.53,18.81-13.25,21.36-19.5c2.64-6.46.57-9.7-1.21-12.49-6.25-9.8-9.15-5.19-9.15-5.19-2.07,3.1-12.37,8-12.37,8l-5.18-1.83s-1.64-13.91-1.32-21.13",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,214.05a2,2,0,0,1,0,.36v1.07c0,1,0,2.34.12,4.15.17,3.63.58,8.91,1.35,15.53l-.11-.13,5.19,1.81h-.13c1.92-.95,3.93-2,6-3.22,1-.6,2.05-1.24,3.06-1.94a16,16,0,0,0,2.86-2.4c.2-.23.37-.49.62-.76a2.87,2.87,0,0,1,.86-.61,3.07,3.07,0,0,1,2.09-.11,8.35,8.35,0,0,1,3.4,2.38l.7.78.65.84c.45.55.83,1.16,1.24,1.75a20.22,20.22,0,0,1,2.14,3.82,10,10,0,0,1,.65,4.48,15.73,15.73,0,0,1-1.08,4.5,13.91,13.91,0,0,1-2.6,4,45.21,45.21,0,0,1-3.34,3.45A158.19,158.19,0,0,1,229,266.35l-.11.08-.12,0c-2.22-.72-4.57-1.52-6.94-2.35-3.36-1.2-6.67-2.43-9.89-3.76a58.82,58.82,0,0,1-9.24-4.57,7.49,7.49,0,0,1-1.93-1.72,8.75,8.75,0,0,1-.89-2.4c-.43-1.62-.71-3.23-1-4.83-.52-3.21-.92-6.36-1.24-9.44-.65-6.15-1-12-1.23-17.53s-.2-10.63.06-15.31c.09-1.17.15-2.31.27-3.42s.28-2.2.53-3.23a20.13,20.13,0,0,1,2.16-5.56,16.62,16.62,0,0,1,6.83-6.55,19.75,19.75,0,0,1,5.71-1.93c.68-.12,1.2-.17,1.55-.2s.54,0,.54,0l-.53.07c-.35,0-.87.1-1.54.24a20.45,20.45,0,0,0-5.63,2,16.45,16.45,0,0,0-6.67,6.52,19.48,19.48,0,0,0-2.1,5.49c-.24,1-.33,2.09-.5,3.18s-.17,2.25-.25,3.41c-.24,4.66-.21,9.79,0,15.28s.62,11.35,1.28,17.49c.32,3.08.73,6.22,1.25,9.4.27,1.59.55,3.21,1,4.79a8.56,8.56,0,0,0,.83,2.24,7.13,7.13,0,0,0,1.8,1.59,58.07,58.07,0,0,0,9.15,4.51c3.2,1.32,6.51,2.56,9.87,3.75,2.36.83,4.71,1.63,6.92,2.34l-.23,0a160.27,160.27,0,0,0,15.59-12.51,46.27,46.27,0,0,0,3.32-3.41,13.48,13.48,0,0,0,2.51-3.83c1.13-2.81,1.56-5.94.46-8.63a20.12,20.12,0,0,0-2.09-3.74c-.4-.59-.77-1.19-1.21-1.73l-.64-.82-.69-.76a8,8,0,0,0-3.19-2.28,2.56,2.56,0,0,0-1.79.09,2.19,2.19,0,0,0-.73.51c-.2.2-.39.48-.61.74a16.54,16.54,0,0,1-2.95,2.46c-1,.71-2.07,1.34-3.1,1.94-2.06,1.2-4.08,2.26-6,3.2l-.07,0-.07,0-5.17-1.84-.1,0v-.09c-.72-6.64-1.08-11.93-1.2-15.56-.07-1.81-.06-3.21,0-4.16,0-.46,0-.81,0-1.07A1.65,1.65,0,0,1,221,214.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.72,232.22l3.55-6.49s.44-3.43.77-5.21a4.84,4.84,0,0,1,2.12-2.85l.18-2.29,3.34-3.86s.43-2.76,2.93-3.19a11.94,11.94,0,0,1,3.2.64c.17,0,2-1.57,3.76-.84a25,25,0,0,1,5.56,3.42c.88.86-2.16,9.53-2.16,9.53l-3.35,7.43-4.7,2.6-7.52,11.75S239.52,240.44,240.72,232.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.15,221.47s.17-.29.69-.55a2.67,2.67,0,0,1,1-.22c.41,0,.86.07,1.34.11a5.28,5.28,0,0,1,.8.09,6.83,6.83,0,0,1,.83.29,17.75,17.75,0,0,1,1.67.86c.57.34,1.16.7,1.75,1.12.29.21.58.44.87.68a2.82,2.82,0,0,1,.81,1,.56.56,0,0,1,0,.47,3.07,3.07,0,0,1-.17.31,3.89,3.89,0,0,1-.41.5,3.18,3.18,0,0,1-1,.75,1.78,1.78,0,0,1-1.26.08,9.21,9.21,0,0,1-1-.36,32,32,0,0,1-3.27-1.57l.2,0a16.52,16.52,0,0,1-2,1.84,15.4,15.4,0,0,1,1.79-2.08l.08-.09.12.05c.88.42,2,.95,3.28,1.44.65.2,1.35.57,1.94.26a3,3,0,0,0,.85-.64,4.82,4.82,0,0,0,.35-.44c.09-.15.2-.34.14-.34a2.77,2.77,0,0,0-.65-.72c-.27-.23-.55-.45-.83-.65-.57-.42-1.14-.79-1.69-1.12a17.59,17.59,0,0,0-1.61-.88,5.58,5.58,0,0,0-.75-.3,5,5,0,0,0-.74-.11,4.46,4.46,0,0,0-2.25-.07C247.42,221.29,247.18,221.51,247.15,221.47Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,221a7.38,7.38,0,0,1,1.13-1l.06-.05.07,0c.94.51,2.36,1.3,4.13,2.2.45.22.91.45,1.4.67a6.9,6.9,0,0,0,1.5.53,2,2,0,0,0,1.48-.44,2.77,2.77,0,0,0,.88-1.41l.1.27,0,0c-2.9-2-5.52-3.91-7.42-5.3l.06,0c-1.19-.36-2.15-.66-2.81-.88a4.71,4.71,0,0,1-1-.39,3.82,3.82,0,0,1,1.07.19c.67.16,1.65.4,2.85.72h0l0,0c1.95,1.31,4.6,3.14,7.5,5.17l0,0,.15.11-.05.16a3.24,3.24,0,0,1-1.05,1.7,2.54,2.54,0,0,1-1.85.54,6.74,6.74,0,0,1-1.66-.6c-.49-.23-1-.47-1.4-.71-1.76-1-3.15-1.8-4.05-2.38h.14A6.71,6.71,0,0,1,251.17,221Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.94,216.43a19.14,19.14,0,0,1,2.92.66h0l0,0c1.1,1.06,2.55,2.52,4.18,4.18l-.17-.08a1.74,1.74,0,0,0,1.6-1c.06-.1.11-.21.15-.29v.18a25.49,25.49,0,0,0-1.57-3.85,6.81,6.81,0,0,0-2.28-2.36,27,27,0,0,1-2.51-1.9,14.45,14.45,0,0,1,2.72,1.6c.4.28.84.59,1.29,1a4.69,4.69,0,0,1,1.19,1.47,23.1,23.1,0,0,1,1.66,3.92l0,.09,0,.09a2.42,2.42,0,0,1-.18.36,2.27,2.27,0,0,1-2.08,1.19h-.1l-.07-.07c-1.61-1.67-3-3.17-4.06-4.29l.08.05A16.75,16.75,0,0,1,254.94,216.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,196s.24.17.61.56a19.37,19.37,0,0,1,1.43,1.71,30.1,30.1,0,0,1,3.67,6.42,31.14,31.14,0,0,1,2,7.1,19.71,19.71,0,0,1,.25,2.23,2.3,2.3,0,0,1,0,.82c-.08,0-.22-1.15-.6-3a38.77,38.77,0,0,0-2.14-7,35.49,35.49,0,0,0-3.49-6.4C213.7,197,213,196.08,213,196Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.2,247.26a10,10,0,0,1,1.34-2.4,25.19,25.19,0,0,1,4.47-4.93,25.9,25.9,0,0,1,5.59-3.59,9.61,9.61,0,0,1,2.59-.93,25.7,25.7,0,0,1-2.42,1.26,30,30,0,0,0-9.93,8.4C210.82,246.41,210.27,247.3,210.2,247.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,247.6a12.45,12.45,0,0,1,3.07-10.16,34.83,34.83,0,0,0-2.17,4.89A33.69,33.69,0,0,0,224.19,247.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.38 190.77 306.19 198.54 306.82 199.7 319.28 196.02 320.8 199.17 290.76 230.15 260.27 230.56 256.7 224.96 284.38 190.77",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.38,190.77l-.13.17-.38.49c-.35.45-.84,1.08-1.48,1.88l-5.6,7c-4.85,6-11.72,14.57-19.91,24.76l0-.27,3.57,5.6-.21-.11,30.5-.43-.18.08c.32-.34.68-.71,1-1.07,10.6-10.93,20.54-21.16,29-29.89l0,.26-1.51-3.15.26.11-12.48,3.65-.14,0-.07-.13-.63-1.17.1.09-15.92-5.77-4.32-1.59-1.13-.42-.38-.16.37.11,1.12.37,4.32,1.49,16.06,5.63.06,0,0,.06c.21.37.41.74.64,1.17l-.21-.09,12.45-3.72.18-.05.08.17,1.52,3.14.07.14-.11.11-29,29.94-1,1.07-.07.08h-.11l-30.5.39h-.14l-.07-.11-3.55-5.61-.09-.14.1-.13,20.15-24.72,5.68-6.92,1.5-1.81.39-.45C284.33,190.81,284.37,190.76,284.38,190.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,231.33c.13-.29,27.22-36,27.22-36L306,199.64l1.52,1.7,13.28-2.17-28.38,32.29-9.13.53-1.87-1.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29,232h0l-1.86-1.21-21.76.56,0,0c.12-.29,26.11-34.59,27.22-36h0L306,199.62h0l1.51,1.69,13.33-2.19,0,.05-28.39,32.31h0Zm-1.86-1.28h0L283.3,232l9.11-.53,28.32-32.24-13.22,2.17h0L306,199.67l-19.05-4.35c-.63.83-26.29,34.68-27.18,36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,201.65a6.55,6.55,0,0,1-.7,1.17c-.53.82-1.22,1.86-2,3.09l-6.77,10.17c-2.66,4-5.11,7.52-7,10-.93,1.26-1.7,2.27-2.25,2.95a6.51,6.51,0,0,1-.9,1,6.91,6.91,0,0,1,.74-1.14c.55-.81,1.26-1.83,2.1-3,1.78-2.58,4.18-6.16,6.83-10.13s5.09-7.52,6.9-10.07c.91-1.28,1.65-2.3,2.18-3A6.58,6.58,0,0,1,308,201.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,199.93a6.55,6.55,0,0,1-.7,1.17c-.53.82-1.22,1.85-2,3.09l-6.77,10.16c-2.66,4-5.11,7.53-7,10.05-.93,1.26-1.7,2.26-2.25,2.95a6.51,6.51,0,0,1-.9,1,6.91,6.91,0,0,1,.74-1.14c.55-.81,1.26-1.83,2.11-3,1.77-2.57,4.17-6.15,6.82-10.12s5.09-7.52,6.9-10.07c.91-1.28,1.65-2.3,2.18-3A6.58,6.58,0,0,1,305.92,199.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,218.18a2,2,0,0,1,1.72.87c.75,1,2.61,5.4,2.24,6.19s-2.2,3.45-2.2,3.45l-.51,2.82s.43,2.12.47,3a9.93,9.93,0,0,1-.6,2.59s-.17,1.47-.24,2.4-1.51,6.48-1.51,6.48l.31,6.11s-3.17,5-8.71.57l-1.64-1.37-.12-4-.41-6s-5.94-6.49-6-6.93-1.17-1.41,0-2.92c0,0-.66-.34-.3-1.51a1.76,1.76,0,0,1,1.28-1.32s-.16-2.6,1.82-3.06c0,0,5.49.52,6.82.61s4.89,2.33,4.89,2.33l2.75-3.91a42.35,42.35,0,0,1-1.07-4.69A1.57,1.57,0,0,1,287.52,218.18Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,238.2a29.93,29.93,0,0,1-6-3,29.14,29.14,0,0,1-5.46-3.83c.08-.13,2.57,1.51,5.73,3.38S282.09,238.06,282,238.2Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.52,234.12c-.1.13-2.4-1.77-5.7-3.27a62.34,62.34,0,0,0-6.2-2.16,6.21,6.21,0,0,1,1.94.21,21.26,21.26,0,0,1,4.48,1.48,21,21,0,0,1,4,2.42A5.8,5.8,0,0,1,283.52,234.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7,230.69c-.09.12-.95-.45-2-1.17s-1.86-1.32-1.79-1.45a4.61,4.61,0,0,1,2.09,1C287.07,229.83,287.79,230.59,287.7,230.69Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.36,243.47c-.09.11-.78-.32-1.44-1.06s-1-1.45-.92-1.53.66.48,1.3,1.18S278.46,243.36,278.36,243.47Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.6561cc55998666533931ebc7cabb90e7.svg";
export { ForwardRef as ReactComponent };